const TRACKER_CODE = String.raw`#include <WiFi.h>
#include <PubSubClient.h>
#include <WiFiManager.h>
#include <Preferences.h>


#if defined(CONFIG_IDF_TARGET_ESP32S3)
  #define RELAY1 6
  #define RELAY2 7
  #define IGNITION_PIN 8
  #define ADC_FUEL 1
  #define BUZZER 9
  #define DISP_TX 17
  #define DISP_RX 18
#else
  #define RELAY1 32
  #define RELAY2 33
  #define IGNITION_PIN 25
  #define ADC_FUEL 34
  #define BUZZER 26
  #define DISP_TX 17
  #define DISP_RX 16
#endif
#define CONFIG_BTN 0

const unsigned long TELEMETRY_MS = 10000;
const unsigned long HEARTBEAT_MS = 30000;
const unsigned long MQTT_RETRY_MS = 10000;
const unsigned long WIFI_CHECK_MS = 5000;

const int MAX_MQTT_FAILURES = 5;
const int MAX_WIFI_FAILURES = 12;

Preferences prefs;

String deviceId = "tracker-buyubampo-01";
String mqttHost = "";
uint16_t mqttPort = 1883;
String mqttUser = "";
String mqttPass = "";

enum Transport { TRANSPORT_WIFI, TRANSPORT_LTE };
Transport transport = TRANSPORT_WIFI;

WiFiClient wifiClient;
PubSubClient mqtt(wifiClient);

String topicData;
String topicStatus;
String topicCmd;
String topicAck;

float demoLat = 24.8091;
float demoLon = -107.3940;
unsigned long lastTelemetry = 0;
unsigned long lastHeartbeat = 0;
unsigned long lastMqttTry = 0;
unsigned long lastWifiCheck = 0;

float demoSpeed = 0;
float demoFuel = 76.0;
float demoBatt = 12.6;
bool demoIgnition = false;
int demoPhase = 0;
unsigned long demoPhaseStart = 0;
const float CRUISE_SPEED = 75.0;

int mqttFailures = 0;
int wifiFailures = 0;

String buildApName() {
  String mac = WiFi.macAddress();
  mac.replace(":", "");
  return "Tracker-" + mac;
}

String buildApPass() {
  String mac = WiFi.macAddress();
  mac.replace(":", "");
  return "Buyubampo-" + mac.substring(mac.length() - 4);
}

String extract(String s, String key) {
  String needle = "\"" + key + "\":";
  int i = s.indexOf(needle);
  if (i < 0) return "";
  i += needle.length();
  while (i < (int)s.length() && (s[i] == ' ' || s[i] == '"')) i++;
  int j = i;
  while (j < (int)s.length() && s[j] != ',' && s[j] != '}' && s[j] != '"') j++;
  return s.substring(i, j);
}

void loadConfig() {
  prefs.begin("tracker", false);
  deviceId = prefs.getString("device_id", deviceId);
  mqttHost = prefs.getString("mqtt_host", "");
  mqttPort = prefs.getUShort("mqtt_port", 1883);
  mqttUser = prefs.getString("mqtt_user", "");
  mqttPass = prefs.getString("mqtt_pass", "");
  prefs.end();
}

void saveConfig() {
  prefs.begin("tracker", false);
  prefs.putString("device_id", deviceId);
  prefs.putString("mqtt_host", mqttHost);
  prefs.putUShort("mqtt_port", mqttPort);
  prefs.putString("mqtt_user", mqttUser);
  prefs.putString("mqtt_pass", mqttPass);
  prefs.end();
}

void setupConfigPortal(bool force) {
  WiFiManager wm;
  WiFiManagerParameter pDevice("device_id", "Device ID", deviceId.c_str(), 40);
  WiFiManagerParameter pHost("mqtt_host", "MQTT Host (IP o dominio)", mqttHost.c_str(), 64);
  WiFiManagerParameter pPort("mqtt_port", "MQTT Port", String(mqttPort).c_str(), 8);
  WiFiManagerParameter pUser("mqtt_user", "MQTT Username", mqttUser.c_str(), 40);
  WiFiManagerParameter pPass("mqtt_pass", "MQTT Password", mqttPass.c_str(), 64);
  wm.addParameter(&pDevice);
  wm.addParameter(&pHost);
  wm.addParameter(&pPort);
  wm.addParameter(&pUser);
  wm.addParameter(&pPass);
  wm.setConfigPortalTimeout(180);
  String apName = buildApName();
  String apPass = buildApPass();
  Serial.println("AP: " + apName);
  if (force || mqttHost.isEmpty()) {
    wm.startConfigPortal(apName.c_str(), apPass.c_str());
  } else {
    wm.autoConnect(apName.c_str(), apPass.c_str());
  }
  deviceId = String(pDevice.getValue());
  mqttHost = String(pHost.getValue());
  mqttPort = atoi(pPort.getValue());
  mqttUser = String(pUser.getValue());
  mqttPass = String(pPass.getValue());
  saveConfig();
}

void sendAck(String id, String status, String result) {
  String msg = "{\"id\":\"" + id + "\",\"status\":\"" + status + "\",\"result\":" + result + "}";
  mqtt.publish(topicAck.c_str(), msg.c_str());
}

void beep() {
  for (int i = 0; i < 3; i++) {
    digitalWrite(BUZZER, HIGH);
    delay(150);
    digitalWrite(BUZZER, LOW);
    delay(100);
  }
}

void onMqttMessage(char* topic, byte* payload, unsigned int length) {
  String msg = "";
  for (unsigned int i = 0; i < length; i++) msg += (char)payload[i];
  Serial.println("cmd <- " + msg);
  String id = extract(msg, "id");
  String type = extract(msg, "type");
  String result = "{}";
  if (type == "relay") {
    int idx = extract(msg, "relay").toInt();
    String onStr = extract(msg, "on");
    bool on = (onStr == "true" || onStr == "1");
    int pin = (idx == 1) ? RELAY1 : (idx == 2 ? RELAY2 : -1);
    if (pin >= 0) digitalWrite(pin, on ? HIGH : LOW);
    result = "{\"relay\":" + String(idx) + ",\"on\":" + (on ? "true" : "false") + "}";
  } else if (type == "message") {
    String text = extract(msg, "text");
    Serial.println("MENSAJE PARA EL CONDUCTOR: " + text);
    Serial1.println("MSG:" + text);
    beep();
    result = "{\"shown\":true}";
  }
  sendAck(id, "ok", result);
}

bool connectTransport() {
  if (transport == TRANSPORT_LTE) {
    return false;
  }
  return WiFi.status() == WL_CONNECTED;
}

void updateDemo() {
  unsigned long elapsed = millis() - demoPhaseStart;
  switch (demoPhase) {
    case 0:
      demoSpeed = (elapsed / 30000.0) * CRUISE_SPEED;
      if (demoSpeed >= CRUISE_SPEED) {
        demoSpeed = CRUISE_SPEED;
        demoPhase = 1;
        demoPhaseStart = millis();
      }
      demoIgnition = true;
      demoBatt = 13.9;
      break;
    case 1:
      demoSpeed = CRUISE_SPEED + sin(millis() / 1500.0) * 2.0;
      if (elapsed > 90000) {
        demoPhase = 2;
        demoPhaseStart = millis();
      }
      demoIgnition = true;
      demoBatt = 14.1;
      break;
    case 2:
      demoSpeed = CRUISE_SPEED * (1.0 - (elapsed / 20000.0));
      if (demoSpeed <= 0) {
        demoSpeed = 0;
        demoPhase = 3;
        demoPhaseStart = millis();
      }
      demoIgnition = true;
      demoBatt = 13.8;
      break;
    case 3:
      demoSpeed = 0;
      demoIgnition = false;
      demoBatt = 12.6;
      if (elapsed > 120000) {
        demoPhase = 0;
        demoPhaseStart = millis();
      }
      break;
  }

  if (demoSpeed > 0) {
    demoLat += (demoSpeed * 10.0 / 3600.0) / 111.0;
    demoLon += (demoSpeed * 10.0 / 3600.0) / (111.0 * cos(demoLat * 3.14159265 / 180.0));
    demoFuel -= 0.02;
    if (demoFuel < 15.0) demoFuel = 76.0;
  }
}

void publishStatus(bool online) {
  String msg = "{\"online\":" + String(online ? "true" : "false") + ",\"batt\":" + String(demoBatt, 1) + "}";
  mqtt.publish(topicStatus.c_str(), msg.c_str());
}

void publishData() {
  updateDemo();
  String msg = "{\"lat\":" + String(demoLat, 6) +
               ",\"lon\":" + String(demoLon, 6) +
               ",\"speed\":" + String(demoSpeed, 1) +
               ",\"bearing\":45" +
               ",\"batt\":" + String(demoBatt, 1) +
               ",\"fuel\":" + String(demoFuel, 1) +
               ",\"ignition\":" + String(demoIgnition ? "true" : "false") + "}";
  mqtt.publish(topicData.c_str(), msg.c_str());
}

void connectMqtt() {
  if (!connectTransport()) return;
  String willMsg = "{\"online\":false}";
  if (mqtt.connect(deviceId.c_str(), mqttUser.c_str(), mqttPass.c_str(),
                   topicStatus.c_str(), 1, true, willMsg.c_str())) {
    mqtt.subscribe(topicCmd.c_str(), 1);
    publishStatus(true);
    Serial.println("mqtt conectado como " + deviceId);
  }
}

void buildTopics() {
  topicData = "devices/" + deviceId + "/data";
  topicStatus = "devices/" + deviceId + "/status";
  topicCmd = "devices/" + deviceId + "/cmd";
  topicAck = "devices/" + deviceId + "/ack";
}

void startRecoveryPortal() {
  Serial.println("modo recuperacion: abriendo portal");
  if (mqtt.connected()) mqtt.disconnect();
  setupConfigPortal(true);
  buildTopics();
  mqtt.setServer(mqttHost.c_str(), mqttPort);
  Serial.println("broker: " + mqttHost + ":" + String(mqttPort));
  mqtt.setCallback(onMqttMessage);
  mqttFailures = 0;
  wifiFailures = 0;
  lastMqttTry = millis();
  lastWifiCheck = millis();
  connectMqtt();
}

void setup() {
  Serial.begin(115200);
  pinMode(RELAY1, OUTPUT);
  pinMode(RELAY2, OUTPUT);
  digitalWrite(RELAY1, LOW);
  digitalWrite(RELAY2, LOW);
  pinMode(IGNITION_PIN, INPUT);
  pinMode(BUZZER, OUTPUT);
  digitalWrite(BUZZER, LOW);
  pinMode(CONFIG_BTN, INPUT_PULLUP);
  Serial1.begin(115200, SERIAL_8N1, DISP_RX, DISP_TX);

  loadConfig();
  bool forceConfig = (digitalRead(CONFIG_BTN) == LOW);
  setupConfigPortal(forceConfig);
  buildTopics();

  mqtt.setServer(mqttHost.c_str(), mqttPort);
  Serial.println("broker: " + mqttHost + ":" + String(mqttPort));
  mqtt.setCallback(onMqttMessage);
  connectMqtt();
}

void loop() {
  if (WiFi.status() != WL_CONNECTED) {
    if (millis() - lastWifiCheck >= WIFI_CHECK_MS) {
      lastWifiCheck = millis();
      wifiFailures++;
      Serial.println("wifi caido " + String(wifiFailures) + "/" + String(MAX_WIFI_FAILURES));
      if (wifiFailures >= MAX_WIFI_FAILURES) {
        startRecoveryPortal();
      }
    }
  } else {
    wifiFailures = 0;
  }

  if (!mqtt.connected()) {
    if (millis() - lastMqttTry >= MQTT_RETRY_MS) {
      lastMqttTry = millis();
      connectMqtt();
      if (!mqtt.connected()) {
        mqttFailures++;
        Serial.println("mqtt fallo " + String(mqttFailures) + "/" + String(MAX_MQTT_FAILURES));
        if (mqttFailures >= MAX_MQTT_FAILURES) {
          startRecoveryPortal();
        }
      } else {
        mqttFailures = 0;
      }
    }
  } else {
    mqttFailures = 0;
  }

  mqtt.loop();

  unsigned long now = millis();
  if (now - lastTelemetry >= TELEMETRY_MS) {
    lastTelemetry = now;
    if (mqtt.connected()) publishData();
  }
  if (now - lastHeartbeat >= HEARTBEAT_MS) {
    lastHeartbeat = now;
    if (mqtt.connected()) publishStatus(true);
  }
}`;

const DISPLAY_CODE = String.raw`#include <Wire.h>
#include <Adafruit_GFX.h>
#include <Adafruit_SSD1306.h>

#define SCREEN_WIDTH 128
#define SCREEN_HEIGHT 64
#define OLED_ADDR 0x3C
#define SDA_PIN 21
#define SCL_PIN 22

#define DISP_RX 16
#define DISP_TX 17

Adafruit_SSD1306 display(SCREEN_WIDTH, SCREEN_HEIGHT, &Wire, -1);

String currentMessage = "";

void showMessage(String text) {
  currentMessage = text;
  display.clearDisplay();
  display.setCursor(0, 0);
  display.setTextColor(SSD1306_WHITE);
  display.setTextSize(1);
  display.println("MENSAJE DEL DESPACHO:");
  display.drawFastHLine(0, 11, SCREEN_WIDTH, SSD1306_WHITE);
  if (text.length() > 40) {
    display.setTextSize(1);
    display.setCursor(0, 16);
  } else {
    display.setTextSize(2);
    display.setCursor(0, 14);
  }
  display.println(text);
  display.display();
}

void setup() {
  Serial.begin(115200);
  Serial1.begin(115200, SERIAL_8N1, DISP_RX, DISP_TX);

  Wire.begin(SDA_PIN, SCL_PIN);
  if (!display.begin(SSD1306_SWITCHCAPVCC, OLED_ADDR)) {
    Serial.println("OLED no encontrada");
    for (;;) delay(1000);
  }
  showMessage("Esperando mensajes...");
}

void loop() {
  if (Serial1.available()) {
    String line = Serial1.readStringUntil('\n');
    line.trim();
    if (line.startsWith("MSG:")) {
      String text = line.substring(4);
      Serial.println("Mostrando: " + text);
      showMessage(text);
    } else if (line == "CLEAR") {
      showMessage("Esperando mensajes...");
    }
  }
}`;

const DEMO_TRACKER_CODE = String.raw`// Demo Tracker - Buyubampo
// ESP32-S que simula un GPS y publica telemetria via MQTT.
// Configuracion (WiFi + broker + topicos) capturada con WiFiManager.

#include <WiFi.h>
#include <PubSubClient.h>
#include <WiFiManager.h>
#include <Preferences.h>


#define CONFIG_BTN 0
#define LED_PIN 2

const unsigned long TELEMETRY_MS = 10000;
const unsigned long HEARTBEAT_MS = 30000;
const unsigned long MQTT_RETRY_MS = 5000;
const unsigned long WIFI_RETRY_MS = 10000;

Preferences prefs;

String deviceId = "tracker-demo-01";
String mqttHost = "";
uint16_t mqttPort = 1883;
String mqttUser = "";
String mqttPass = "";

String topicPub = "devices/{id}/data";
String topicStatus = "devices/{id}/status";
String topicSub = "devices/{id}/cmd";
String topicAck = "devices/{id}/ack";

WiFiClient wifiClient;
PubSubClient mqtt(wifiClient);

unsigned long lastTelemetry = 0;
unsigned long lastHeartbeat = 0;
unsigned long lastMqttTry = 0;

// ---- simulacion GPS ----
float demoLat = 24.8091;
float demoLon = -107.3940;
float demoSpeed = 0.0;
float demoFuel = 76.0;
float demoBatt = 12.6;
bool demoIgnition = false;
int demoPhase = 0;
unsigned long demoPhaseStart = 0;
const float CRUISE_SPEED = 75.0;

String buildApName() {
  String mac = WiFi.macAddress();
  mac.replace(":", "");
  return "Tracker-" + mac;
}

String buildApPass() {
  String mac = WiFi.macAddress();
  mac.replace(":", "");
  return "Buyubampo-" + mac.substring(mac.length() - 4);
}

String extract(String s, String key) {
  String needle = "\"" + key + "\":";
  int i = s.indexOf(needle);
  if (i < 0) return "";
  i += needle.length();
  while (i < (int)s.length() && (s[i] == ' ' || s[i] == '"')) i++;
  int j = i;
  while (j < (int)s.length() && s[j] != ',' && s[j] != '}' && s[j] != '"') j++;
  return s.substring(i, j);
}

void loadConfig() {
  prefs.begin("demo", false);
  deviceId = prefs.getString("device_id", deviceId);
  mqttHost = prefs.getString("mqtt_host", "");
  mqttPort = prefs.getUShort("mqtt_port", 1883);
  mqttUser = prefs.getString("mqtt_user", "");
  mqttPass = prefs.getString("mqtt_pass", "");
  topicPub = prefs.getString("topic_pub", topicPub);
  topicStatus = prefs.getString("topic_status", topicStatus);
  topicSub = prefs.getString("topic_sub", topicSub);
  topicAck = prefs.getString("topic_ack", topicAck);
  prefs.end();
}

void saveConfig() {
  prefs.begin("demo", false);
  prefs.putString("device_id", deviceId);
  prefs.putString("mqtt_host", mqttHost);
  prefs.putUShort("mqtt_port", mqttPort);
  prefs.putString("mqtt_user", mqttUser);
  prefs.putString("mqtt_pass", mqttPass);
  prefs.putString("topic_pub", topicPub);
  prefs.putString("topic_status", topicStatus);
  prefs.putString("topic_sub", topicSub);
  prefs.putString("topic_ack", topicAck);
  prefs.end();
}

String applyId(String t) {
  t.replace("{id}", deviceId);
  return t;
}

void setupConfigPortal(bool force) {
  WiFiManager wm;
  WiFiManagerParameter pDevice("device_id", "Device ID", deviceId.c_str(), 40);
  WiFiManagerParameter pHost("mqtt_host", "MQTT Host (IP o dominio)", mqttHost.c_str(), 64);
  WiFiManagerParameter pPort("mqtt_port", "MQTT Port", String(mqttPort).c_str(), 8);
  WiFiManagerParameter pUser("mqtt_user", "MQTT Username", mqttUser.c_str(), 40);
  WiFiManagerParameter pPass("mqtt_pass", "MQTT Password", mqttPass.c_str(), 64);
  WiFiManagerParameter pPub("topic_pub", "Topico publicar (data)", topicPub.c_str(), 64);
  WiFiManagerParameter pStatus("topic_status", "Topico estado (status)", topicStatus.c_str(), 64);
  WiFiManagerParameter pSub("topic_sub", "Topico suscribir (cmd)", topicSub.c_str(), 64);
  WiFiManagerParameter pAck("topic_ack", "Topico ack", topicAck.c_str(), 64);

  wm.addParameter(&pDevice);
  wm.addParameter(&pHost);
  wm.addParameter(&pPort);
  wm.addParameter(&pUser);
  wm.addParameter(&pPass);
  wm.addParameter(&pPub);
  wm.addParameter(&pStatus);
  wm.addParameter(&pSub);
  wm.addParameter(&pAck);

  wm.setConfigPortalTimeout(180);
  String apName = buildApName();
  String apPass = buildApPass();
  Serial.println("AP: " + apName);

  if (force || mqttHost.isEmpty()) {
    wm.startConfigPortal(apName.c_str(), apPass.c_str());
  } else {
    wm.autoConnect(apName.c_str(), apPass.c_str());
  }

  deviceId = String(pDevice.getValue());
  mqttHost = String(pHost.getValue());
  mqttPort = atoi(pPort.getValue());
  mqttUser = String(pUser.getValue());
  mqttPass = String(pPass.getValue());
  topicPub = String(pPub.getValue());
  topicStatus = String(pStatus.getValue());
  topicSub = String(pSub.getValue());
  topicAck = String(pAck.getValue());
  saveConfig();
}

void sendAck(String id, String status, String result) {
  String msg = "{\"id\":\"" + id + "\",\"status\":\"" + status + "\",\"result\":" + result + "}";
  mqtt.publish(applyId(topicAck).c_str(), msg.c_str());
}

void onMqttMessage(char* topic, byte* payload, unsigned int length) {
  String msg = "";
  for (unsigned int i = 0; i < length; i++) msg += (char)payload[i];
  Serial.println("cmd <- " + msg);
  String id = extract(msg, "id");
  String type = extract(msg, "type");
  String result = "{}";
  if (type == "message") {
    String text = extract(msg, "text");
    Serial.println("MENSAJE: " + text);
    result = "{\"shown\":true}";
  }
  sendAck(id, "ok", result);
}

bool connectMqtt() {
  if (WiFi.status() != WL_CONNECTED) return false;
  String willMsg = "{\"online\":false}";
  if (mqtt.connect(deviceId.c_str(), mqttUser.c_str(), mqttPass.c_str(),
                   applyId(topicStatus).c_str(), 1, true, willMsg.c_str())) {
    mqtt.subscribe(applyId(topicSub).c_str(), 1);
    Serial.println("mqtt conectado como " + deviceId);
    mqtt.publish(applyId(topicStatus).c_str(), "{\"online\":true}");
    return true;
  }
  return false;
}

void updateDemo() {
  unsigned long elapsed = millis() - demoPhaseStart;
  switch (demoPhase) {
    case 0:
      demoSpeed = (elapsed / 30000.0) * CRUISE_SPEED;
      if (demoSpeed >= CRUISE_SPEED) {
        demoSpeed = CRUISE_SPEED;
        demoPhase = 1;
        demoPhaseStart = millis();
      }
      demoIgnition = true;
      demoBatt = 13.9;
      break;
    case 1:
      demoSpeed = CRUISE_SPEED + sin(millis() / 1500.0) * 2.0;
      if (elapsed > 90000) {
        demoPhase = 2;
        demoPhaseStart = millis();
      }
      demoIgnition = true;
      demoBatt = 14.1;
      break;
    case 2:
      demoSpeed = CRUISE_SPEED * (1.0 - (elapsed / 20000.0));
      if (demoSpeed <= 0) {
        demoSpeed = 0;
        demoPhase = 3;
        demoPhaseStart = millis();
      }
      demoIgnition = true;
      demoBatt = 13.8;
      break;
    case 3:
      demoSpeed = 0;
      demoIgnition = false;
      demoBatt = 12.6;
      if (elapsed > 120000) {
        demoPhase = 0;
        demoPhaseStart = millis();
      }
      break;
  }

  if (demoSpeed > 0) {
    demoLat += (demoSpeed * 10.0 / 3600.0) / 111.0;
    demoLon += (demoSpeed * 10.0 / 3600.0) / (111.0 * cos(demoLat * 3.14159265 / 180.0));
    demoFuel -= 0.02;
    if (demoFuel < 15.0) demoFuel = 76.0;
  }
}

void publishData() {
  updateDemo();
  String msg = "{\"lat\":" + String(demoLat, 6) +
               ",\"lon\":" + String(demoLon, 6) +
               ",\"speed\":" + String(demoSpeed, 1) +
               ",\"bearing\":45" +
               ",\"batt\":" + String(demoBatt, 1) +
               ",\"fuel\":" + String(demoFuel, 1) +
               ",\"ignition\":" + String(demoIgnition ? "true" : "false") + "}";
  mqtt.publish(applyId(topicPub).c_str(), msg.c_str());
}

void setup() {
  Serial.begin(115200);
  pinMode(LED_PIN, OUTPUT);
  pinMode(CONFIG_BTN, INPUT_PULLUP);

  loadConfig();
  bool forceConfig = (digitalRead(CONFIG_BTN) == LOW);
  setupConfigPortal(forceConfig);

  Serial.println("broker: " + mqttHost + ":" + String(mqttPort));
  mqtt.setServer(mqttHost.c_str(), mqttPort);
  mqtt.setCallback(onMqttMessage);
  connectMqtt();
}

void loop() {
  if (WiFi.status() != WL_CONNECTED) {
    digitalWrite(LED_PIN, HIGH);
    if (millis() - lastMqttTry >= WIFI_RETRY_MS) {
      lastMqttTry = millis();
      Serial.println("wifi caido, reintentando...");
      WiFi.reconnect();
    }
    return;
  }
  digitalWrite(LED_PIN, LOW);

  if (!mqtt.connected()) {
    if (millis() - lastMqttTry >= MQTT_RETRY_MS) {
      lastMqttTry = millis();
      connectMqtt();
    }
  }

  mqtt.loop();

  unsigned long now = millis();
  if (now - lastTelemetry >= TELEMETRY_MS) {
    lastTelemetry = now;
    if (mqtt.connected()) publishData();
  }
  if (now - lastHeartbeat >= HEARTBEAT_MS) {
    lastHeartbeat = now;
    if (mqtt.connected()) mqtt.publish(applyId(topicStatus).c_str(), "{\"online\":true}");
  }
}`;

const NODEMCU_TRACKER_CODE = String.raw`/*
 * Buyubampo - Tracker de ejemplo para Lolin NodeMCU v3 (ESP8266)
 * ---------------------------------------------------------------
 * Adaptacion del tracker ESP32 para el NodeMCU v3 (ESP-12E / ESP8266).
 *
 * Cambios respecto al ESP32:
 *   - WiFi:      ESP8266WiFi.h  (en vez de WiFi.h)
 *   - Guardado:  EEPROM.h       (en vez de Preferences.h)
 *   - Sin Serial1: el mensaje al conductor se muestra por Serial
 *                (opcionalmente via SoftwareSerial hacia un display)
 *   - ADC:       un solo canal (A0), 10 bits (0..1023), 0..3.3V
 *
 * Librerias necesarias (Arduino IDE / PlatformIO):
 *   - Board: "NodeMCU 1.0 (ESP-12E Module)"  (o "LOLIN(WEMOS) D1 mini" NO; usa NodeMCU)
 *   - PubSubClient (knolleary)
 *   - WiFiManager  (tzapu)
 *
 * Convencion de topicos (igual que el backend):
 *   devices/{id}/data     -> telemetria (publicar)
 *   devices/{id}/status   -> heartbeat / LWT (publicar)
 *   devices/{id}/cmd      -> comandos (suscribir)
 *   devices/{id}/ack      -> confirmacion (publicar)
 *
 * Comandos soportados: relay (1|2, on) y message (text).
 *
 * Al primer arranque (o manteniendo GPIO0 pulsado) se abre un portal WiFi
 * para capturar el Device ID, el broker y las credenciales MQTT.
 * SSID: Tracker-<MAC>   Password: derivada del MAC (ver Serial)
 */

#include <ESP8266WiFi.h>
#include <PubSubClient.h>
#include <WiFiManager.h>
#include <EEPROM.h>

#define MQTT_MAX_PACKET_SIZE 512


// ---- Pines (Lolin NodeMCU v3 / ESP-12E) ----
// Nota: evita usar D3(GPIO0), D4(GPIO2) y D8(GPIO15) como salidas
// porque tienen restricciones de arranque (estado de boot).
#define RELAY1       D1   // GPIO5  -> rele 1 (corta-corriente)
#define RELAY2       D2   // GPIO4  -> rele 2
#define IGNITION_PIN D5   // GPIO14 -> entrada de ignicion (12V -> divisor -> 3.3V)
#define BUZZER       D6   // GPIO12 -> buzzer pasivo
#define CONFIG_BTN   D3   // GPIO0  -> boton FLASH (forzar portal de config)
#define LED_PIN      LED_BUILTIN  // LED de estado (GPIO2 en la mayoria)

// ---- Intervalos ----
const unsigned long TELEMETRY_MS = 10000;
const unsigned long HEARTBEAT_MS = 30000;
const unsigned long MQTT_RETRY_MS = 5000;
const unsigned long WIFI_RETRY_MS  = 10000;

// ---- Configuracion persistida en EEPROM ----
const int ADDR_DEVICE_ID = 0;     // 40 bytes
const int ADDR_HOST      = 40;    // 64 bytes
const int ADDR_PORT      = 104;   // 2 bytes
const int ADDR_USER      = 106;   // 40 bytes
const int ADDR_PASS      = 146;   // 64 bytes
const int ADDR_MAGIC     = 210;   // 1 byte
const uint8_t EEPROM_MAGIC = 0xA5;

String deviceId = "tracker-nodemcu-01";
String mqttHost = "";
uint16_t mqttPort = 1883;
String mqttUser = "";
String mqttPass = "";

String topicData;
String topicStatus;
String topicCmd;
String topicAck;

WiFiClient wifiClient;
PubSubClient mqtt(wifiClient);

unsigned long lastTelemetry = 0;
unsigned long lastHeartbeat = 0;
unsigned long lastMqttTry   = 0;

// ---- Simulacion GPS (demo) ----
float demoLat = 24.8091;
float demoLon = -107.3940;
float demoSpeed = 0.0;
float demoFuel = 76.0;
float demoBatt = 12.6;
bool  demoIgnition = false;
int   demoPhase = 0;
unsigned long demoPhaseStart = 0;
const float CRUISE_SPEED = 75.0;

// ---------- EEPROM ----------
void eepromWriteStr(int addr, const String& s, int maxLen) {
  int n = s.length();
  if (n > maxLen - 1) n = maxLen - 1;
  for (int i = 0; i < n; i++) EEPROM.write(addr + i, s[i]);
  EEPROM.write(addr + n, 0);
}

String eepromReadStr(int addr, int maxLen) {
  String out = "";
  for (int i = 0; i < maxLen; i++) {
    char c = (char)EEPROM.read(addr + i);
    if (c == 0) break;
    out += c;
  }
  return out;
}

void loadConfig() {
  EEPROM.begin(512);
  if (EEPROM.read(ADDR_MAGIC) != EEPROM_MAGIC) {
    EEPROM.end();
    return; // sin config previa: se abre el portal
  }
  deviceId = eepromReadStr(ADDR_DEVICE_ID, 40);
  mqttHost = eepromReadStr(ADDR_HOST, 64);
  mqttPort = EEPROM.read(ADDR_PORT) | (EEPROM.read(ADDR_PORT + 1) << 8);
  mqttUser = eepromReadStr(ADDR_USER, 40);
  mqttPass = eepromReadStr(ADDR_PASS, 64);
  if (deviceId.length() == 0) deviceId = "tracker-nodemcu-01";
  EEPROM.end();
}

void saveConfig() {
  EEPROM.begin(512);
  eepromWriteStr(ADDR_DEVICE_ID, deviceId, 40);
  eepromWriteStr(ADDR_HOST, mqttHost, 64);
  EEPROM.write(ADDR_PORT, mqttPort & 0xFF);
  EEPROM.write(ADDR_PORT + 1, (mqttPort >> 8) & 0xFF);
  eepromWriteStr(ADDR_USER, mqttUser, 40);
  eepromWriteStr(ADDR_PASS, mqttPass, 64);
  EEPROM.write(ADDR_MAGIC, EEPROM_MAGIC);
  EEPROM.commit();
  EEPROM.end();
}

// ---------- Utilidades ----------
String buildApName() {
  String mac = WiFi.macAddress();
  mac.replace(":", "");
  return "Tracker-" + mac;
}

String buildApPass() {
  String mac = WiFi.macAddress();
  mac.replace(":", "");
  return "Buyubampo-" + mac.substring(mac.length() - 4);
}

String extract(String s, String key) {
  String needle = "\"" + key + "\":";
  int i = s.indexOf(needle);
  if (i < 0) return "";
  i += needle.length();
  while (i < (int)s.length() && (s[i] == ' ' || s[i] == '"')) i++;
  int j = i;
  while (j < (int)s.length() && s[j] != ',' && s[j] != '}' && s[j] != '"') j++;
  return s.substring(i, j);
}

void beep() {
  for (int i = 0; i < 3; i++) {
    digitalWrite(BUZZER, HIGH);
    delay(150);
    digitalWrite(BUZZER, LOW);
    delay(100);
  }
}

void buildTopics() {
  topicData   = "devices/" + deviceId + "/data";
  topicStatus = "devices/" + deviceId + "/status";
  topicCmd    = "devices/" + deviceId + "/cmd";
  topicAck    = "devices/" + deviceId + "/ack";
}

// ---------- Config / WiFiManager ----------
void setupConfigPortal(bool force) {
  WiFiManager wm;
  WiFiManagerParameter pDevice("device_id", "Device ID", deviceId.c_str(), 40);
  WiFiManagerParameter pHost("mqtt_host", "MQTT Host (IP o dominio)", mqttHost.c_str(), 64);
  WiFiManagerParameter pPort("mqtt_port", "MQTT Port", String(mqttPort).c_str(), 8);
  WiFiManagerParameter pUser("mqtt_user", "MQTT Username", mqttUser.c_str(), 40);
  WiFiManagerParameter pPass("mqtt_pass", "MQTT Password", mqttPass.c_str(), 64);
  wm.addParameter(&pDevice);
  wm.addParameter(&pHost);
  wm.addParameter(&pPort);
  wm.addParameter(&pUser);
  wm.addParameter(&pPass);
  wm.setConfigPortalTimeout(180);
  String apName = buildApName();
  String apPass = buildApPass();
  Serial.println("AP: " + apName);

  if (force || mqttHost.isEmpty()) {
    wm.startConfigPortal(apName.c_str(), apPass.c_str());
  } else {
    wm.autoConnect(apName.c_str(), apPass.c_str());
  }

  deviceId = String(pDevice.getValue());
  mqttHost = String(pHost.getValue());
  mqttPort = atoi(pPort.getValue());
  mqttUser = String(pUser.getValue());
  mqttPass = String(pPass.getValue());
  saveConfig();
}

// ---------- Comandos ----------
void sendAck(String id, String status, String result) {
  String msg = "{\"id\":\"" + id + "\",\"status\":\"" + status + "\",\"result\":" + result + "}";
  mqtt.publish(topicAck.c_str(), msg.c_str());
}

void onMqttMessage(char* topic, byte* payload, unsigned int length) {
  String msg = "";
  for (unsigned int i = 0; i < length; i++) msg += (char)payload[i];
  Serial.println("cmd <- " + msg);
  String id = extract(msg, "id");
  String type = extract(msg, "type");
  String result = "{}";
  if (type == "relay") {
    int idx = extract(msg, "relay").toInt();
    String onStr = extract(msg, "on");
    bool on = (onStr == "true" || onStr == "1");
    int pin = (idx == 1) ? RELAY1 : (idx == 2 ? RELAY2 : -1);
    if (pin >= 0) digitalWrite(pin, on ? HIGH : LOW);
    result = "{\"relay\":" + String(idx) + ",\"on\":" + (on ? "true" : "false") + "}";
  } else if (type == "message") {
    String text = extract(msg, "text");
    Serial.println("MENSAJE PARA EL CONDUCTOR: " + text);
    beep();
    result = "{\"shown\":true}";
  }
  sendAck(id, "ok", result);
}

// ---------- MQTT ----------
bool connectMqtt() {
  if (WiFi.status() != WL_CONNECTED) return false;
  String willMsg = "{\"online\":false}";
  if (mqtt.connect(deviceId.c_str(), mqttUser.c_str(), mqttPass.c_str(),
                   topicStatus.c_str(), 1, true, willMsg.c_str())) {
    mqtt.subscribe(topicCmd.c_str(), 1);
    mqtt.publish(topicStatus.c_str(), "{\"online\":true}");
    Serial.println("mqtt conectado como " + deviceId);
    return true;
  }
  return false;
}

// ---------- Telemetria (demo) ----------
void updateDemo() {
  unsigned long elapsed = millis() - demoPhaseStart;
  switch (demoPhase) {
    case 0:
      demoSpeed = (elapsed / 30000.0) * CRUISE_SPEED;
      if (demoSpeed >= CRUISE_SPEED) { demoSpeed = CRUISE_SPEED; demoPhase = 1; demoPhaseStart = millis(); }
      demoIgnition = true; demoBatt = 13.9;
      break;
    case 1:
      demoSpeed = CRUISE_SPEED + sin(millis() / 1500.0) * 2.0;
      if (elapsed > 90000) { demoPhase = 2; demoPhaseStart = millis(); }
      demoIgnition = true; demoBatt = 14.1;
      break;
    case 2:
      demoSpeed = CRUISE_SPEED * (1.0 - (elapsed / 20000.0));
      if (demoSpeed <= 0) { demoSpeed = 0; demoPhase = 3; demoPhaseStart = millis(); }
      demoIgnition = true; demoBatt = 13.8;
      break;
    case 3:
      demoSpeed = 0; demoIgnition = false; demoBatt = 12.6;
      if (elapsed > 120000) { demoPhase = 0; demoPhaseStart = millis(); }
      break;
  }

  if (demoSpeed > 0) {
    demoLat += (demoSpeed * 10.0 / 3600.0) / 111.0;
    demoLon += (demoSpeed * 10.0 / 3600.0) / (111.0 * cos(demoLat * 3.14159265 / 180.0));
    demoFuel -= 0.02;
    if (demoFuel < 15.0) demoFuel = 76.0;
  }
}

// Lee el combustible real por ADC (opcional). El NodeMCU tiene un divisor
// integrado que lee 0..3.3V en A0 (10 bits). Descomenta y cambia demoFuel
// en updateDemo() si quieres usar el sensor real.
float readFuelAdc() {
  int raw = analogRead(A0);          // 0..1023
  return (raw / 1023.0) * 100.0;     // % (0..100)
}

void publishData() {
  updateDemo();
  // Si conectas un sensor de nivel en A0, usa: demoFuel = readFuelAdc();
  String msg = "{\"lat\":" + String(demoLat, 6) +
               ",\"lon\":" + String(demoLon, 6) +
               ",\"speed\":" + String(demoSpeed, 1) +
               ",\"bearing\":45" +
               ",\"batt\":" + String(demoBatt, 1) +
               ",\"fuel\":" + String(demoFuel, 1) +
               ",\"ignition\":" + String(demoIgnition ? "true" : "false") + "}";
  mqtt.publish(topicData.c_str(), msg.c_str());
}

void publishStatus(bool online) {
  String msg = "{\"online\":" + String(online ? "true" : "false") +
               ",\"batt\":" + String(demoBatt, 1) + "}";
  mqtt.publish(topicStatus.c_str(), msg.c_str());
}

// ---------- Boot / loop ----------
void setup() {
  Serial.begin(115200);
  pinMode(RELAY1, OUTPUT);
  pinMode(RELAY2, OUTPUT);
  digitalWrite(RELAY1, LOW);
  digitalWrite(RELAY2, LOW);
  pinMode(IGNITION_PIN, INPUT);
  pinMode(BUZZER, OUTPUT);
  digitalWrite(BUZZER, LOW);
  pinMode(CONFIG_BTN, INPUT_PULLUP);
  pinMode(LED_PIN, OUTPUT);
  digitalWrite(LED_PIN, HIGH);

  loadConfig();
  bool forceConfig = (digitalRead(CONFIG_BTN) == LOW);
  setupConfigPortal(forceConfig);
  buildTopics();

  mqtt.setServer(mqttHost.c_str(), mqttPort);
  mqtt.setCallback(onMqttMessage);
  Serial.println("broker: " + mqttHost + ":" + String(mqttPort));
  connectMqtt();
}

void loop() {
  if (WiFi.status() != WL_CONNECTED) {
    digitalWrite(LED_PIN, HIGH);
    if (millis() - lastMqttTry >= WIFI_RETRY_MS) {
      lastMqttTry = millis();
      Serial.println("wifi caido, reintentando...");
      WiFi.reconnect();
    }
    return;
  }
  digitalWrite(LED_PIN, LOW);

  if (!mqtt.connected()) {
    if (millis() - lastMqttTry >= MQTT_RETRY_MS) {
      lastMqttTry = millis();
      connectMqtt();
    }
  }

  mqtt.loop();

  unsigned long now = millis();
  if (now - lastTelemetry >= TELEMETRY_MS) {
    lastTelemetry = now;
    if (mqtt.connected()) publishData();
  }
  if (now - lastHeartbeat >= HEARTBEAT_MS) {
    lastHeartbeat = now;
    if (mqtt.connected()) publishStatus(true);
  }
}`;

const DOCKER_COMPOSE = `services:
  db:
    image: mariadb:10.11
    container_name: mysql_db
    restart: unless-stopped
    environment:
      MYSQL_ROOT_PASSWORD: <CONTRASENA_ROOT>
      MYSQL_DATABASE: traccar_db
      MYSQL_USER: usuario
      MYSQL_PASSWORD: <CONTRASENA_USUARIO>
    volumes:
      - db_data:/var/lib/mysql
    networks: [net_iot]

  traccar:
    image: traccar/traccar:latest
    container_name: traccar
    restart: unless-stopped
    ports: ["8082:8082", "5023:5023"]
    volumes:
      - ./traccar/conf/traccar.xml:/opt/traccar/conf/traccar.xml:ro
      - traccar_logs:/opt/traccar/logs
    depends_on: [db]
    networks: [net_iot]

  emqx:
    image: emqx/emqx:5.8.0
    container_name: emqx
    restart: unless-stopped
    ports: ["1883:1883", "8083:8083", "18083:18083"]
    volumes:
      - emqx_data:/opt/emqx/data
      - emqx_log:/opt/emqx/log
      - ./emqx/etc/acl.conf:/opt/emqx/etc/acl.conf:ro
    networks: [net_iot]

  iot-backend:
    build: ./iot
    container_name: iot_backend
    restart: unless-stopped
    ports: ["127.0.0.1:3000:3000"]
    environment:
      - MQTT_URL=mqtt://emqx:1883
      - MQTT_USERNAME=backend
      - MQTT_PASSWORD=<CONTRASENA_MQTT_BACKEND>
      - MYSQL_HOST=mysql_db
      - MYSQL_PORT=3306
      - MYSQL_USER=usuario
      - MYSQL_PASSWORD=<CONTRASENA_USUARIO>
      - MYSQL_DATABASE=iot
      - EMQX_API_BASE=http://emqx:18083
      - EMQX_API_KEY=<API_KEY_EMQX>
      - EMQX_API_SECRET=<API_SECRET_EMQX>
      - TRACCAR_ENABLED=true
      - TRACCAR_URL=http://traccar:5055
      - TRACCAR_API_BASE=http://traccar:8082
      - TRACCAR_API_EMAIL=<EMAIL_TRACCAR>
      - TRACCAR_API_PASSWORD=<PASS_TRACCAR>
      - SMTP_HOST=smtp.hostinger.com
      - SMTP_PORT=465
      - SMTP_USER=<CORREO_REMITENTE>
      - SMTP_PASS=<PASS_SMTP>
      - SMTP_FROM=<CORREO_REMITENTE>
      - BASE_URL=https://iot.buyubampo.com
    depends_on: [db, emqx]
    networks: [net_iot]

  nginx-proxy-manager:
    image: jc21/nginx-proxy-manager:latest
    container_name: nginx-proxy-manager
    restart: unless-stopped
    ports: ["80:80", "81:81", "443:443"]
    volumes:
      - ./npm/data:/data
      - ./npm/letsencrypt:/etc/letsencrypt
    depends_on: [db]
    networks: [net_iot]

networks:
  net_iot:
    driver: bridge

volumes:
  db_data:
  traccar_logs:
  emqx_data:
  emqx_log:`;

const DOCKERFILE = `# ---- Etapa 1: construir el frontend React ----
FROM node:20-alpine AS frontend-build
WORKDIR /build/frontend
COPY frontend/package*.json ./
RUN npm install
COPY frontend/ ./
RUN npm run build

# ---- Etapa 2: backend Node.js + estáticos ----
FROM node:20-alpine
WORKDIR /app
COPY backend/package*.json ./
RUN npm install --omit=dev
COPY backend/ ./
COPY firmware/ ./firmware
COPY --from=frontend-build /build/frontend/dist ./public
ENV NODE_ENV=production
EXPOSE 3000
CMD ["node", "server.js"]`;

const PAYLOAD_EXAMPLE = `// Telemetria en devices/{id}/data
{
  "lat": 24.8091,
  "lon": -107.3940,
  "speed": 75.4,        // km/h
  "bearing": 45,        // grados
  "batt": 13.8,         // voltios
  "fuel": 76,           // % (0-100)
  "ignition": true,
  "ts": 1725033600000
}`;

const TTS_HTTP_CODE = String.raw`/*
 * Buyubampo - Unidad de voz por HTTP directo (sin MQTT)
 * ---------------------------------------------------------------
 * Llama directamente a la API del backend:
 *
 *   GET https://iot.buyubampo.com/api/tts?key=API_KEY&text=Hola&format=wav
 *
 * El backend responde un WAV (PCM 16-bit / 16 kHz / mono) que se
 * reproduce por I2S con un amplificador MAX98357A.
 *
 * Disparadores:
 *   - Serial:  escribir  SAY:Hola mundo
 *   - Boton:   pulso corto en TTS_BTN (envia la frase SAY_PHRASE)
 *
 * Librerias necesarias (Arduino IDE / PlatformIO):
 *   - WiFiManager (tzapu)
 *   - Espressif arduino-esp32 (usa driver/i2s.h incluido)
 *
 * NO necesita PubSubClient (no usa MQTT).
 */

#include <WiFi.h>
#include <WiFiManager.h>
#include <Preferences.h>
#include <HTTPClient.h>
#include <WiFiClientSecure.h>
#include "driver/i2s.h"


// --- Pines I2S (MAX98357A) ---
#if defined(CONFIG_IDF_TARGET_ESP32S3)
  #define I2S_BCK  15
  #define I2S_WS   16
  #define I2S_DOUT 7
#else
  #define I2S_BCK  26
  #define I2S_WS   25
  #define I2S_DOUT 22
#endif

#define TTS_BTN 0
#define SAY_PHRASE "Hola, soy Buyubampo"

#define SAMPLE_RATE 16000

Preferences prefs;

String apiKey = ""; // configurar vía portal
String baseUrl = "https://iot.buyubampo.com";

WiFiClientSecure secureClient;

unsigned long lastBtn = 0;
bool lastBtnState = HIGH;

String buildApName() {
  String mac = WiFi.macAddress();
  mac.replace(":", "");
  return "VozHTTP-" + mac;
}

String buildApPass() {
  String mac = WiFi.macAddress();
  mac.replace(":", "");
  return "Buyubampo-" + mac.substring(mac.length() - 4);
}

// Codifica una cadena para usarla como query string (RFC 3986).
String urlEncode(String s) {
  String out = "";
  const char* hex = "0123456789ABCDEF";
  for (size_t i = 0; i < s.length(); i++) {
    char c = s[i];
    if ((c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') ||
        (c >= '0' && c <= '9') || c == '-' || c == '_' || c == '.' || c == '~') {
      out += c;
    } else {
      out += '%';
      out += hex[(c >> 4) & 0xF];
      out += hex[c & 0xF];
    }
  }
  return out;
}

void loadConfig() {
  prefs.begin("ttshttp", false);
  String savedKey = prefs.getString("api_key", "");
  if (savedKey.length() > 0) apiKey = savedKey;
  String savedUrl = prefs.getString("base_url", "");
  if (savedUrl.length() > 0) baseUrl = savedUrl;
  prefs.end();
}

void saveConfig() {
  prefs.begin("ttshttp", false);
  prefs.putString("api_key", apiKey);
  prefs.putString("base_url", baseUrl);
  prefs.end();
}

void setupConfigPortal(bool force) {
  WiFiManager wm;
  WiFiManagerParameter pKey("api_key", "API Key", apiKey.c_str(), 64);
  WiFiManagerParameter pUrl("base_url", "Base URL", baseUrl.c_str(), 64);
  wm.addParameter(&pKey);
  wm.addParameter(&pUrl);
  wm.setConfigPortalTimeout(180);
  String apName = buildApName();
  String apPass = buildApPass();
  if (force || apiKey.isEmpty()) {
    wm.startConfigPortal(apName.c_str(), apPass.c_str());
  } else {
    wm.autoConnect(apName.c_str(), apPass.c_str());
  }
  apiKey = String(pKey.getValue());
  baseUrl = String(pUrl.getValue());
  saveConfig();
}

// ---------- I2S ----------
void initI2S() {
  i2s_config_t cfg = {
    .mode = (i2s_mode_t)(I2S_MODE_MASTER | I2S_MODE_TX),
    .sample_rate = SAMPLE_RATE,
    .bits_per_sample = I2S_BITS_PER_SAMPLE_16BIT,
    .channel_format = I2S_CHANNEL_FMT_ONLY_LEFT,
    .communication_format = I2S_COMM_FORMAT_STAND_I2S,
    .intr_alloc_flags = ESP_INTR_FLAG_LEVEL1,
    .dma_buf_count = 8,
    .dma_buf_len = 128,
    .use_apll = false,
    .tx_desc_auto_clear = true,
    .fixed_mclk = 0,
  };
  i2s_pin_config_t pins = {
    .bck_io_num = I2S_BCK,
    .ws_io_num = I2S_WS,
    .data_out_num = I2S_DOUT,
    .data_in_num = I2S_PIN_NO_CHANGE,
  };
  i2s_driver_install(I2S_NUM_0, &cfg, 0, NULL);
  i2s_set_pin(I2S_NUM_0, &pins);
  i2s_zero_dma_buffer(I2S_NUM_0);
}

void playPcm(WiFiClient* client, uint32_t dataSize) {
  uint8_t buf[1024];
  uint32_t remaining = dataSize;
  while (remaining > 0 && client->connected()) {
    size_t chunk = remaining < sizeof(buf) ? remaining : sizeof(buf);
    size_t got = 0;
    while (got < chunk) {
      int r = client->read(buf + got, chunk - got);
      if (r <= 0) break;
      got += r;
    }
    if (got == 0) break;
    size_t written = 0;
    i2s_write(I2S_NUM_0, buf, got, &written, portMAX_DELAY);
    remaining -= got;
  }
  i2s_zero_dma_buffer(I2S_NUM_0);
}

// ---------- Sintetizar y reproducir ----------
void say(String text) {
  text.trim();
  if (text.length() == 0) return;
  String url = baseUrl + "/api/tts?key=" + urlEncode(apiKey) +
               "&text=" + urlEncode(text) + "&format=wav";
  Serial.println("GET " + url);

  secureClient.setInsecure(); // en produccion, usar la CA de Let's Encrypt
  HTTPClient http;
  http.begin(secureClient, url);
  http.setTimeout(20000);
  int code = http.GET();
  if (code != HTTP_CODE_OK) {
    Serial.println("HTTP error " + String(code));
    http.end();
    return;
  }
  WiFiClient* stream = http.getStreamPtr();

  // Cabecera RIFF (12 bytes)
  uint8_t riff[12];
  if (stream->readBytes(riff, 12) != 12) { http.end(); return; }
  if (memcmp(riff, "RIFF", 4) != 0 || memcmp(riff + 8, "WAVE", 4) != 0) {
    Serial.println("No es un WAV");
    http.end();
    return;
  }

  // Recorrer chunks hasta encontrar "data"
  uint32_t dataSize = 0;
  while (true) {
    uint8_t ch[8];
    if (stream->readBytes(ch, 8) != 8) break;
    uint32_t sz = (uint32_t)ch[4] | ((uint32_t)ch[5] << 8) | ((uint32_t)ch[6] << 16) | ((uint32_t)ch[7] << 24);
    if (memcmp(ch, "data", 4) == 0) {
      dataSize = sz;
      break;
    }
    uint32_t skip = sz + (sz & 1);
    while (skip > 0) {
      uint8_t tmp[64];
      size_t want = skip < sizeof(tmp) ? skip : sizeof(tmp);
      int r = stream->read(tmp, want);
      if (r <= 0) break;
      skip -= r;
    }
  }

  if (dataSize == 0) {
    Serial.println("Chunk data no encontrado");
    http.end();
    return;
  }
  Serial.println("Reproduciendo " + String(dataSize) + " bytes");
  playPcm(stream, dataSize);
  http.end();
}

void setup() {
  Serial.begin(115200);
  pinMode(TTS_BTN, INPUT_PULLUP);

  loadConfig();
  bool forceConfig = (digitalRead(TTS_BTN) == LOW);
  setupConfigPortal(forceConfig);

  initI2S();
  lastBtnState = digitalRead(TTS_BTN);
  lastBtn = millis();
  Serial.println("Listo. Escribe SAY:hola mundo, o pulsa el boton.");
}

void loop() {
  if (Serial.available()) {
    String line = Serial.readStringUntil('\n');
    line.trim();
    if (line.startsWith("SAY:")) {
      say(line.substring(4));
    }
  }

  bool btnState = digitalRead(TTS_BTN);
  if (btnState == LOW && lastBtnState == HIGH) {
    if (millis() - lastBtn > 1000) {
      lastBtn = millis();
      say(SAY_PHRASE);
    }
  }
  lastBtnState = btnState;
}`;

const TTS_MQTT_CODE = String.raw`/*
 * Buyubampo - Unidad de voz (Text-to-Speech)
 * ---------------------------------------------------------------
 * Flujo:
 *   1) El ESP32 publica {"text":"..."} en devices/{id}/tts
 *   2) El backend genera un WAV (PCM 16-bit / 16 kHz / mono)
 *      y publica {"url":"..."} en devices/{id}/tts/audio
 *   3) El ESP32 descarga el WAV por HTTPS y lo reproduce por I2S
 *      con un amplificador MAX98357A.
 *
 * Disparadores para enviar texto:
 *   - Serial:  escribir  SAY:Hola mundo
 *   - Boton:   pulso corto en TTS_BTN (envia la frase de SAY_PHRASE)
 *
 * Librerias necesarias (Arduino IDE / PlatformIO):
 *   - PubSubClient (knolleary)
 *   - WiFiManager (tzapu)
 *   - Espressif arduino-esp32 (usa driver/i2s.h incluido)
 */

#include <WiFi.h>
#include <PubSubClient.h>
#include <WiFiManager.h>
#include <Preferences.h>
#include <HTTPClient.h>
#include <WiFiClientSecure.h>
#include "driver/i2s.h"


// --- Pines I2S (MAX98357A) ---
#if defined(CONFIG_IDF_TARGET_ESP32S3)
  #define I2S_BCK  15
  #define I2S_WS   16
  #define I2S_DOUT 7
#else
  #define I2S_BCK  26
  #define I2S_WS   25
  #define I2S_DOUT 22
#endif

#define TTS_BTN 0
#define SAY_PHRASE "Hola, soy Buyubampo"

#define SAMPLE_RATE 16000

Preferences prefs;

String deviceId = "tts-buyubampo-01";
String mqttHost = "";
uint16_t mqttPort = 1883;
String mqttUser = "";
String mqttPass = "";

WiFiClient wifiClient;
WiFiClientSecure secureClient;
PubSubClient mqtt(wifiClient);

String topicTts;       // devices/{id}/tts       (publicar texto)
String topicTtsAudio;  // devices/{id}/tts/audio (recibir URL)

unsigned long lastBtn = 0;
bool lastBtnState = HIGH;

String buildApName() {
  String mac = WiFi.macAddress();
  mac.replace(":", "");
  return "Voz-" + mac;
}

String buildApPass() {
  String mac = WiFi.macAddress();
  mac.replace(":", "");
  return "Buyubampo-" + mac.substring(mac.length() - 4);
}

String extract(String s, String key) {
  String needle = "\"" + key + "\":";
  int i = s.indexOf(needle);
  if (i < 0) return "";
  i += needle.length();
  while (i < (int)s.length() && (s[i] == ' ' || s[i] == '"')) i++;
  int j = i;
  while (j < (int)s.length() && s[j] != ',' && s[j] != '}' && s[j] != '"') j++;
  return s.substring(i, j);
}

String escapeJson(String s) {
  s.replace("\\", "\\\\");
  s.replace("\"", "\\\"");
  return s;
}

void loadConfig() {
  prefs.begin("tts", false);
  deviceId = prefs.getString("device_id", deviceId);
  mqttHost = prefs.getString("mqtt_host", "");
  mqttPort = prefs.getUShort("mqtt_port", 1883);
  mqttUser = prefs.getString("mqtt_user", "");
  mqttPass = prefs.getString("mqtt_pass", "");
  prefs.end();
}

void saveConfig() {
  prefs.begin("tts", false);
  prefs.putString("device_id", deviceId);
  prefs.putString("mqtt_host", mqttHost);
  prefs.putUShort("mqtt_port", mqttPort);
  prefs.putString("mqtt_user", mqttUser);
  prefs.putString("mqtt_pass", mqttPass);
  prefs.end();
}

void setupConfigPortal(bool force) {
  WiFiManager wm;
  WiFiManagerParameter pDevice("device_id", "Device ID", deviceId.c_str(), 40);
  WiFiManagerParameter pHost("mqtt_host", "MQTT Host (IP o dominio)", mqttHost.c_str(), 64);
  WiFiManagerParameter pPort("mqtt_port", "MQTT Port", String(mqttPort).c_str(), 8);
  WiFiManagerParameter pUser("mqtt_user", "MQTT Username", mqttUser.c_str(), 40);
  WiFiManagerParameter pPass("mqtt_pass", "MQTT Password", mqttPass.c_str(), 64);
  wm.addParameter(&pDevice);
  wm.addParameter(&pHost);
  wm.addParameter(&pPort);
  wm.addParameter(&pUser);
  wm.addParameter(&pPass);
  wm.setConfigPortalTimeout(180);
  String apName = buildApName();
  String apPass = buildApPass();
  if (force || mqttHost.isEmpty()) {
    wm.startConfigPortal(apName.c_str(), apPass.c_str());
  } else {
    wm.autoConnect(apName.c_str(), apPass.c_str());
  }
  deviceId = String(pDevice.getValue());
  mqttHost = String(pHost.getValue());
  mqttPort = atoi(pPort.getValue());
  mqttUser = String(pUser.getValue());
  mqttPass = String(pPass.getValue());
  saveConfig();
}

void buildTopics() {
  topicTts = "devices/" + deviceId + "/tts";
  topicTtsAudio = "devices/" + deviceId + "/tts/audio";
}

// ---------- I2S ----------
void initI2S() {
  i2s_config_t cfg = {
    .mode = (i2s_mode_t)(I2S_MODE_MASTER | I2S_MODE_TX),
    .sample_rate = SAMPLE_RATE,
    .bits_per_sample = I2S_BITS_PER_SAMPLE_16BIT,
    .channel_format = I2S_CHANNEL_FMT_ONLY_LEFT,
    .communication_format = I2S_COMM_FORMAT_STAND_I2S,
    .intr_alloc_flags = ESP_INTR_FLAG_LEVEL1,
    .dma_buf_count = 8,
    .dma_buf_len = 128,
    .use_apll = false,
    .tx_desc_auto_clear = true,
    .fixed_mclk = 0,
  };
  i2s_pin_config_t pins = {
    .bck_io_num = I2S_BCK,
    .ws_io_num = I2S_WS,
    .data_out_num = I2S_DOUT,
    .data_in_num = I2S_PIN_NO_CHANGE,
  };
  i2s_driver_install(I2S_NUM_0, &cfg, 0, NULL);
  i2s_set_pin(I2S_NUM_0, &pins);
  i2s_zero_dma_buffer(I2S_NUM_0);
}

void playPcm(WiFiClient* client, uint32_t dataSize) {
  uint8_t buf[1024];
  uint32_t remaining = dataSize;
  while (remaining > 0 && client->connected()) {
    size_t chunk = remaining < sizeof(buf) ? remaining : sizeof(buf);
    size_t got = 0;
    while (got < chunk) {
      int r = client->read(buf + got, chunk - got);
      if (r <= 0) break;
      got += r;
    }
    if (got == 0) break;
    size_t written = 0;
    i2s_write(I2S_NUM_0, buf, got, &written, portMAX_DELAY);
    remaining -= got;
  }
  i2s_zero_dma_buffer(I2S_NUM_0);
}

// ---------- Descarga y reproduccion del WAV ----------
void handleTtsUrl(String url) {
  Serial.println("Descargando: " + url);
  secureClient.setInsecure(); // en produccion, usar la CA de Let's Encrypt
  HTTPClient http;
  http.begin(secureClient, url);
  http.setTimeout(20000);
  int code = http.GET();
  if (code != HTTP_CODE_OK) {
    Serial.println("HTTP error " + String(code));
    http.end();
    return;
  }
  WiFiClient* stream = http.getStreamPtr();

  // Cabecera RIFF (12 bytes)
  uint8_t riff[12];
  if (stream->readBytes(riff, 12) != 12) { http.end(); return; }
  if (memcmp(riff, "RIFF", 4) != 0 || memcmp(riff + 8, "WAVE", 4) != 0) {
    Serial.println("No es un WAV");
    http.end();
    return;
  }

  // Recorrer chunks hasta encontrar "data"
  uint32_t dataSize = 0;
  while (true) {
    uint8_t ch[8];
    if (stream->readBytes(ch, 8) != 8) break;
    uint32_t sz = (uint32_t)ch[4] | ((uint32_t)ch[5] << 8) | ((uint32_t)ch[6] << 16) | ((uint32_t)ch[7] << 24);
    if (memcmp(ch, "data", 4) == 0) {
      dataSize = sz;
      break;
    }
    // saltar este chunk (alineado a 2)
    uint32_t skip = sz + (sz & 1);
    while (skip > 0) {
      uint8_t tmp[64];
      size_t want = skip < sizeof(tmp) ? skip : sizeof(tmp);
      int r = stream->read(tmp, want);
      if (r <= 0) break;
      skip -= r;
    }
  }

  if (dataSize == 0) {
    Serial.println("Chunk data no encontrado");
    http.end();
    return;
  }
  Serial.println("Reproduciendo " + String(dataSize) + " bytes");
  playPcm(stream, dataSize);
  http.end();
}

// ---------- MQTT ----------
void onMqttMessage(char* topic, byte* payload, unsigned int length) {
  String msg = "";
  for (unsigned int i = 0; i < length; i++) msg += (char)payload[i];
  Serial.println("audio <- " + msg);
  String url = extract(msg, "url");
  if (url.length() > 0) {
    handleTtsUrl(url);
  }
}

void requestTts(String text) {
  text.trim();
  if (text.length() == 0) return;
  String msg = "{\"text\":\"" + escapeJson(text) + "\"}";
  Serial.println("tts -> " + msg);
  mqtt.publish(topicTts.c_str(), msg.c_str());
}

void connectMqtt() {
  if (WiFi.status() != WL_CONNECTED) return;
  if (mqtt.connect(deviceId.c_str(), mqttUser.c_str(), mqttPass.c_str())) {
    mqtt.subscribe(topicTtsAudio.c_str(), 1);
    Serial.println("mqtt conectado como " + deviceId);
  }
}

void setup() {
  Serial.begin(115200);
  pinMode(TTS_BTN, INPUT_PULLUP);

  loadConfig();
  bool forceConfig = (digitalRead(TTS_BTN) == LOW);
  setupConfigPortal(forceConfig);
  buildTopics();

  mqtt.setServer(mqttHost.c_str(), mqttPort);
  mqtt.setCallback(onMqttMessage);
  connectMqtt();

  initI2S();
  lastBtnState = digitalRead(TTS_BTN);
  lastBtn = millis();
  Serial.println("Listo. Escribe SAY:hola mundo, o pulsa el boton.");
}

void loop() {
  if (!mqtt.connected()) {
    static unsigned long lastTry = 0;
    if (millis() - lastTry >= 10000) {
      lastTry = millis();
      connectMqtt();
    }
  }
  mqtt.loop();

  // Serial: SAY:texto
  if (Serial.available()) {
    String line = Serial.readStringUntil('\n');
    line.trim();
    if (line.startsWith("SAY:")) {
      String text = line.substring(4);
      requestTts(text);
    }
  }

  // Boton: envio de frase (flanco de bajada + debounce)
  bool btnState = digitalRead(TTS_BTN);
  if (btnState == LOW && lastBtnState == HIGH) {
    if (millis() - lastBtn > 1000) {
      lastBtn = millis();
      requestTts(SAY_PHRASE);
    }
  }
  lastBtnState = btnState;
}`;

const TTS_DAC_CODE = String.raw`/*
 * Buyubampo - Unidad de voz con DAC interno (solo ESP32 clasico)
 * ---------------------------------------------------------------
 * Variante para escuchar audio SIN el amplificador MAX98357A.
 * Usa el DAC interno de 8 bits del ESP32 original (GPIO25/GPIO26).
 *
 *   IMPORTANTE: NO funciona en ESP32-S2/S3/C3 (no tienen DAC interno).
 *   Para esos modelos usa tts_speaker.ino o tts_speaker_http.ino
 *   con un MAX98357A.
 *
 * Flujo:
 *   GET https://iot.buyubampo.com/api/tts?key=API_KEY&text=Hola&format=wav
 *   -> el backend responde WAV PCM 16-bit / 16 kHz / mono
 *   -> se convierte a 8-bit y se saca por el DAC interno.
 *
 * Disparadores:
 *   - Serial:  escribir  SAY:Hola mundo
 *   - Boton:   pulso corto en TTS_BTN (envia la frase SAY_PHRASE)
 *
 * Librerias necesarias (Arduino IDE / PlatformIO):
 *   - WiFiManager (tzapu)
 *   - Espressif arduino-esp32 (usa driver/i2s.h incluido)
 *
 * Cableado de audio:
 *   GPIO25 (DAC izquierdo) --[ capacitor 100-470uF, + hacia el GPIO ]--> amplificador
 *   GND                     ----------------------------------------------------------> GND amplificador
 *   El amplificador puede ser un PAM8403, un LM386 o unos parlantes de PC
 *   activos (entrada AUX). El capacitor bloquea el offset DC del DAC (~0.7V).
 *
 * NOTA: salida 8-bit/mono. Suficiente para voz, no para musica.
 */

#include <WiFi.h>
#include <WiFiManager.h>
#include <Preferences.h>
#include <HTTPClient.h>
#include <WiFiClientSecure.h>
#include "driver/i2s.h"

// Solo el ESP32 clasico tiene DAC interno
#if !defined(CONFIG_IDF_TARGET_ESP32)
  #error "Este sketch usa el DAC interno y solo funciona en ESP32 clasico (no S2/S3/C3)."
#endif


// El DAC interno usa GPIO25 (izq) y GPIO26 (der); no se configuran pines I2S.
#define TTS_BTN 0
#define SAY_PHRASE "Hola, soy Buyubampo"

#define SAMPLE_RATE 16000

Preferences prefs;

String apiKey = ""; // configurar vía portal
String baseUrl = "https://iot.buyubampo.com";

WiFiClientSecure secureClient;

unsigned long lastBtn = 0;
bool lastBtnState = HIGH;

String buildApName() {
  String mac = WiFi.macAddress();
  mac.replace(":", "");
  return "VozDAC-" + mac;
}

String buildApPass() {
  String mac = WiFi.macAddress();
  mac.replace(":", "");
  return "Buyubampo-" + mac.substring(mac.length() - 4);
}

// Codifica una cadena para usarla como query string (RFC 3986).
String urlEncode(String s) {
  String out = "";
  const char* hex = "0123456789ABCDEF";
  for (size_t i = 0; i < s.length(); i++) {
    char c = s[i];
    if ((c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') ||
        (c >= '0' && c <= '9') || c == '-' || c == '_' || c == '.' || c == '~') {
      out += c;
    } else {
      out += '%';
      out += hex[(c >> 4) & 0xF];
      out += hex[c & 0xF];
    }
  }
  return out;
}

void loadConfig() {
  prefs.begin("ttsdac", false);
  String savedKey = prefs.getString("api_key", "");
  if (savedKey.length() > 0) apiKey = savedKey;
  String savedUrl = prefs.getString("base_url", "");
  if (savedUrl.length() > 0) baseUrl = savedUrl;
  prefs.end();
}

void saveConfig() {
  prefs.begin("ttsdac", false);
  prefs.putString("api_key", apiKey);
  prefs.putString("base_url", baseUrl);
  prefs.end();
}

void setupConfigPortal(bool force) {
  WiFiManager wm;
  WiFiManagerParameter pKey("api_key", "API Key", apiKey.c_str(), 64);
  WiFiManagerParameter pUrl("base_url", "Base URL", baseUrl.c_str(), 64);
  wm.addParameter(&pKey);
  wm.addParameter(&pUrl);
  wm.setConfigPortalTimeout(180);
  String apName = buildApName();
  String apPass = buildApPass();
  if (force || apiKey.isEmpty()) {
    wm.startConfigPortal(apName.c_str(), apPass.c_str());
  } else {
    wm.autoConnect(apName.c_str(), apPass.c_str());
  }
  apiKey = String(pKey.getValue());
  baseUrl = String(pUrl.getValue());
  saveConfig();
}

// ---------- I2S en modo DAC interno ----------
void initI2S() {
  i2s_config_t cfg = {
    .mode = (i2s_mode_t)(I2S_MODE_MASTER | I2S_MODE_TX | I2S_MODE_DAC_BUILT_IN),
    .sample_rate = SAMPLE_RATE,
    .bits_per_sample = I2S_BITS_PER_SAMPLE_16BIT,
    .channel_format = I2S_CHANNEL_FMT_RIGHT_LEFT,
    .communication_format = I2S_COMM_FORMAT_STAND_I2S,
    .intr_alloc_flags = ESP_INTR_FLAG_LEVEL1,
    .dma_buf_count = 8,
    .dma_buf_len = 128,
    .use_apll = false,
    .tx_desc_auto_clear = true,
    .fixed_mclk = 0,
  };
  i2s_driver_install(I2S_NUM_0, &cfg, 0, NULL);
  i2s_set_dac_mode(I2S_DAC_CHANNEL_BOTH_EN); // GPIO25 + GPIO26
  i2s_zero_dma_buffer(I2S_NUM_0);
}

// Convierte el WAV (PCM 16-bit mono) a 8-bit y lo saca por el DAC.
void playPcm(WiFiClient* client, uint32_t dataSize) {
  int16_t sample;
  uint16_t frame[2]; // canal izquierdo + derecho (mismo dato, mono)
  uint32_t remaining = dataSize;
  while (remaining >= 2 && client->connected()) {
    if (client->readBytes((uint8_t*)&sample, 2) != 2) break;
    remaining -= 2;
    uint8_t dac8 = (uint8_t)((sample >> 8) + 0x80); // -32768..32767 -> 0..255
    uint16_t v = (uint16_t)(dac8 << 8);             // valor en el byte alto
    frame[0] = v;
    frame[1] = v;
    size_t written = 0;
    i2s_write(I2S_NUM_0, frame, sizeof(frame), &written, portMAX_DELAY);
  }
  i2s_zero_dma_buffer(I2S_NUM_0);
}

// ---------- Sintetizar y reproducir ----------
void say(String text) {
  text.trim();
  if (text.length() == 0) return;
  String url = baseUrl + "/api/tts?key=" + urlEncode(apiKey) +
               "&text=" + urlEncode(text) + "&format=wav";
  Serial.println("GET " + url);

  secureClient.setInsecure(); // en produccion, usar la CA de Let's Encrypt
  HTTPClient http;
  http.begin(secureClient, url);
  http.setTimeout(20000);
  int code = http.GET();
  if (code != HTTP_CODE_OK) {
    Serial.println("HTTP error " + String(code));
    http.end();
    return;
  }
  WiFiClient* stream = http.getStreamPtr();

  // Cabecera RIFF (12 bytes)
  uint8_t riff[12];
  if (stream->readBytes(riff, 12) != 12) { http.end(); return; }
  if (memcmp(riff, "RIFF", 4) != 0 || memcmp(riff + 8, "WAVE", 4) != 0) {
    Serial.println("No es un WAV");
    http.end();
    return;
  }

  // Recorrer chunks hasta encontrar "data"
  uint32_t dataSize = 0;
  while (true) {
    uint8_t ch[8];
    if (stream->readBytes(ch, 8) != 8) break;
    uint32_t sz = (uint32_t)ch[4] | ((uint32_t)ch[5] << 8) | ((uint32_t)ch[6] << 16) | ((uint32_t)ch[7] << 24);
    if (memcmp(ch, "data", 4) == 0) {
      dataSize = sz;
      break;
    }
    uint32_t skip = sz + (sz & 1);
    while (skip > 0) {
      uint8_t tmp[64];
      size_t want = skip < sizeof(tmp) ? skip : sizeof(tmp);
      int r = stream->read(tmp, want);
      if (r <= 0) break;
      skip -= r;
    }
  }

  if (dataSize == 0) {
    Serial.println("Chunk data no encontrado");
    http.end();
    return;
  }
  Serial.println("Reproduciendo " + String(dataSize) + " bytes por DAC interno");
  playPcm(stream, dataSize);
  http.end();
}

void setup() {
  Serial.begin(115200);
  pinMode(TTS_BTN, INPUT_PULLUP);

  loadConfig();
  bool forceConfig = (digitalRead(TTS_BTN) == LOW);
  setupConfigPortal(forceConfig);

  initI2S();
  lastBtnState = digitalRead(TTS_BTN);
  lastBtn = millis();
  Serial.println("Listo (DAC interno, GPIO25/26). Escribe SAY:hola mundo, o pulsa el boton.");
}

void loop() {
  if (Serial.available()) {
    String line = Serial.readStringUntil('\n');
    line.trim();
    if (line.startsWith("SAY:")) {
      say(line.substring(4));
    }
  }

  bool btnState = digitalRead(TTS_BTN);
  if (btnState == LOW && lastBtnState == HIGH) {
    if (millis() - lastBtn > 1000) {
      lastBtn = millis();
      say(SAY_PHRASE);
    }
  }
  lastBtnState = btnState;
}`;

export default function Ayuda({ isSuperadmin = false, token = '' }) {
  async function fetchManual(path, filename, inline) {
    try {
      const res = await fetch(path, { headers: token ? { Authorization: 'Bearer ' + token } : {} });
      if (!res.ok) {
        alert('No tienes permiso para acceder al manual (requiere superadmin).');
        return;
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      if (inline) {
        window.open(url, '_blank');
      } else {
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) {
      alert('Error al obtener el manual: ' + e.message);
    }
  }

  return (
    <div className="manual">
      <section className="card">
        <h1>Manual Técnico y de Operación — Plataforma Buyubampo</h1>
        <p className="lead">
          Buyubampo es una plataforma IoT multi-empresa (multi-tenant) de rastreo satelital, telemetría y
          control remoto para flotillas, logística, transporte y —en expansión— el ecosistema agrícola. Recibe
          datos de dispositivos ESP32 por MQTT, los procesa, los almacena, los muestra en tiempo real y permite
          controlarlos mediante <strong>comandos</strong> y <strong>automatizaciones</strong>.
        </p>
        {isSuperadmin && (
          <div className="manual-downloads">
            <button type="button" className="btn btn-primary" onClick={() => fetchManual('/manual-tecnico.pdf', 'Manual técnico plataforma buyubampo.pdf', true)}>
              📕 Manual Técnico Plataforma Buyubampo (PDF)
            </button>
            <button type="button" className="btn" onClick={() => fetchManual('/manual-tecnico', 'Manual técnico plataforma buyubampo.md', false)}>
              📄 Manual Técnico Plataforma Buyubampo (Markdown)
            </button>
            <button type="button" className="btn btn-primary" onClick={() => fetchManual('/manual-codigo.pdf', 'Manual de código plataforma buyubampo.pdf', true)}>
              📘 Manual de Código — todo el código fuente (PDF)
            </button>
            <button type="button" className="btn" onClick={() => fetchManual('/manual-codigo', 'Manual de código plataforma buyubampo.md', false)}>
              📄 Manual de Código — todo el código fuente (Markdown)
            </button>
          </div>
        )}
        <div className="toc">
          <ol>
            <li><a href="#arquitectura">Arquitectura</a></li>
            <li><a href="#requisitos">Requisitos de instalación</a></li>
            <li><a href="#instalacion">Instalación paso a paso</a></li>
            <li><a href="#scripts">Scripts de despliegue (código completo)</a></li>
            <li><a href="#acceso">Roles y acceso</a></li>
            <li><a href="#operativo">Uso operativo (con ejemplos)</a></li>
            <li><a href="#topicos">Tópicos MQTT y telemetría</a></li>
            <li><a href="#comandos">Comandos</a></li>
            <li><a href="#firmware">Firmware (código completo)</a></li>
            <li><a href="#api">API (endpoints completos)</a></li>
            <li><a href="#usos">Usos y alcances</a></li>
            <li><a href="#agregados">Posibles agregados (dispositivos y plataforma)</a></li>
            <li><a href="#agricola">Ecosistema de sensores agrícolas</a></li>
            <li><a href="#tts">Text-to-Speech (TTS) — Unidades de voz</a></li>
          </ol>
        </div>
      </section>

      <section className="card" id="arquitectura">
        <h2>1. Arquitectura</h2>
        <p>La plataforma está compuesta por los siguientes bloques, todos orquestados con <strong>Docker Compose</strong>:</p>
        <table>
          <thead><tr><th>Componente</th><th>Rol</th><th>Puerto</th></tr></thead>
          <tbody>
            <tr><td><strong>EMQX</strong></td><td>Broker MQTT (comunicación con los dispositivos)</td><td className="mono">1883</td></tr>
            <tr><td><strong>Traccar</strong></td><td>Motor GPS / historial de posiciones (localización satelital)</td><td className="mono">5055 / 8082</td></tr>
            <tr><td><strong>MariaDB</strong></td><td>Base de datos propia (telemetría, alarmas, empresas, usuarios, viajes…)</td><td className="mono">3306</td></tr>
            <tr><td><strong>Backend (Node.js)</strong></td><td>API REST + WebSocket (Socket.IO) + reenvío a Traccar + alarmas/automatizaciones</td><td className="mono">3000</td></tr>
            <tr><td><strong>Frontend (React/Vite)</strong></td><td>Dashboard y paneles (servido como estáticos por el backend)</td><td className="mono">—</td></tr>
            <tr><td><strong>Nginx Proxy Manager</strong></td><td>Proxy inverso, dominios y certificados SSL</td><td className="mono">80/443/81</td></tr>
          </tbody>
        </table>
        <p>Flujo de un dato de telemetría:</p>
        <ol>
          <li>El <strong>ESP32</strong> publica en <code className="inline">devices/&#123;id&#125;/data</code> hacia EMQX.</li>
          <li>El <strong>backend</strong> está suscrito a <code className="inline">devices/+/data</code>; guarda la telemetría y la emite por WebSocket al dashboard.</li>
          <li>El backend <strong>reenvía la posición</strong> (lat/lon/velocidad) a Traccar por el protocolo OsmAnd (<code className="inline">http://traccar:5055/?id=…&amp;lat=…&amp;lon=…</code>).</li>
          <li>Traccar almacena el historial; el backend lo consulta por dispositivo y empresa para mapa, flota, recorridos y reportes.</li>
        </ol>
        <p><strong>Aislamiento multi-empresa:</strong> Traccar ve todos los dispositivos en una sola base global
          (identificados por su <code className="inline">uniqueId</code>/IMEI); el aislamiento por empresa lo hace el backend
          filtrando por <code className="inline">tenant_id</code> en cada consulta.</p>
      </section>

      <section className="card" id="requisitos">
        <h2>2. Requisitos de instalación</h2>
        <h3>Servidor</h3>
        <ul>
          <li>Linux con <strong>Docker</strong> y <strong>Docker Compose</strong> (v2).</li>
          <li>Mínimo sugerido: 2 vCPU, 4 GB RAM, 40 GB disco. Para flotas grandes, escalar según telemetría.</li>
          <li>IP pública con los puertos <strong>80</strong>, <strong>443</strong>, <strong>1883</strong> (MQTT) y opcional <strong>8082</strong>/<strong>5023</strong> (Traccar) abiertos.</li>
        </ul>
        <h3>Dominios y DNS</h3>
        <ul>
          <li><code className="inline">iot.buyubampo.com</code> → IP del servidor (app y API).</li>
          <li><code className="inline">mqtt.buyubampo.com</code> → IP (broker MQTT de los dispositivos).</li>
          <li><code className="inline">gps.buyubampo.com</code> → IP (Traccar).</li>
        </ul>
        <h3>Servicios externos</h3>
        <ul>
          <li>Cuenta SMTP (ej. Hostinger) para confirmación de cuenta y recuperación de contraseña.</li>
          <li>(Opcional) Bot de Telegram y/o CallMeBot para notificaciones.</li>
        </ul>
        <h3>Dispositivos</h3>
        <ul>
          <li>ESP32 (S3 o clásico) por vehículo/máquina.</li>
          <li>Módulo GPS (o NEO-6M) y antena; relés (corta-corriente), sensor de ignición, ADC de combustible.</li>
          <li>Arduino IDE con el core <strong>esp32</strong> y las librerías <strong>PubSubClient</strong> y <strong>WiFiManager</strong>.</li>
        </ul>
      </section>

      <section className="card" id="instalacion">
        <h2>3. Instalación paso a paso</h2>
        <ol>
          <li>Clonar/copiar el proyecto en el servidor (la raíz contiene <code className="inline">docker-compose.yml</code> y la carpeta <code className="inline">iot/</code> con el Dockerfile).</li>
          <li>Crear el archivo de configuración de Traccar en <code className="inline">./traccar/conf/traccar.xml</code> apuntando a la base MariaDB.</li>
          <li>Reemplazar los valores <code className="inline">&lt;…&gt;</code> del <code className="inline">docker-compose.yml</code> por las credenciales reales.</li>
          <li>Levantar la pila: <pre className="code">docker compose up -d --build</pre></li>
          <li>Configurar <strong>Nginx Proxy Manager</strong> (panel en <code className="inline">http://IP:81</code>): crear Proxy Hosts para <code className="inline">iot</code>, <code className="inline">mqtt</code> y <code className="inline">gps</code> apuntando a los contenedores, con certificados Let's Encrypt y “Force SSL”.</li>
          <li>En NPM, cambiar el “Default Site” a <strong>redirección</strong> hacia <code className="inline">https://iot.buyubampo.com</code> para evitar la página “Congratulations”.</li>
          <li>Configurar el SMTP en las variables de entorno del backend (variables <code className="inline">SMTP_*</code> y <code className="inline">BASE_URL</code>).</li>
          <li>Entrar a <code className="inline">https://iot.buyubampo.com</code>; en el primer arranque se crean el superadmin <code className="inline">admin</code> y el usuario <code className="inline">mecanico</code>.</li>
        </ol>
        <p>La base de datos propia (<code className="inline">iot</code>) tiene las tablas: <code className="inline">tenants</code>,
          <code className="inline">users</code>, <code className="inline">devices</code>, <code className="inline">telemetry</code>,
          <code className="inline">alerts</code>, <code className="inline">commands</code>, <code className="inline">geofences</code>,
          <code className="inline">automations</code>, <code className="inline">maintenance</code>, <code className="inline">trips</code> y
          <code className="inline">settings</code>.</p>
      </section>

      <section className="card" id="scripts">
        <h2>4. Scripts de despliegue (código completo)</h2>
        <h3>4.1. Dockerfile (build del backend + frontend)</h3>
        <pre className="code">{DOCKERFILE}</pre>
        <h3>4.2. docker-compose.yml (pila completa)</h3>
        <p>Los valores marcados como <code className="inline">&lt;…&gt;</code> deben reemplazarse por las credenciales reales (no se incluyen aquí por seguridad).</p>
        <pre className="code">{DOCKER_COMPOSE}</pre>
        <p>
          El firmware compilable se publica también en
          <code className="inline"> https://iot.buyubampo.com/firmware/tracker_v1/tracker_v1.ino</code> y
          <code className="inline"> …/firmware/display_unit/display_unit.ino</code>.
        </p>
      </section>

      <section className="card" id="acceso">
        <h2>5. Roles y acceso</h2>
        <p>La plataforma vive en <code className="inline">https://iot.buyubampo.com</code>. Roles:</p>
        <ul>
          <li><strong>superadmin</strong> — gestiona empresas (multi-tenant): ve el reporte de empresas, entra a operar cada empresa, crea administradores y usuarios. Al entrar ve el selector de empresas.</li>
          <li><strong>admin</strong> — administra su empresa: dispositivos, comandos, alarmas, geocercas, automatizaciones, reportes, combustible, mantenimiento, relevadores, mensajes, usuarios.</li>
          <li><strong>despachador</strong> — operación diaria: mapas, recorridos, viajes, mensajes al conductor, comandos.</li>
          <li><strong>mecanico</strong> — solo mantenimiento (marcar servicios como hechos).</li>
        </ul>
        <p>Acceso por <strong>correo</strong> (o usuario). Hay confirmación de cuenta por correo y recuperación de contraseña. El registro público de empresas crea una empresa + su administrador.</p>
        <p>En la cabecera, el icono <strong>sol/luna</strong> alterna modo claro/oscuro.</p>
      </section>

      <section className="card" id="operativo">
        <h2>6. Uso operativo (con ejemplos)</h2>
        <p>El <strong>Dashboard</strong> es la vista base. Las demás secciones se abren como <strong>ventanas flotantes</strong> desde el menú o desde los iconos de cada dispositivo.</p>

        <h3>6.1. Dashboard (resumen)</h3>
        <ul>
          <li>Tarjetas: mensajes totales, dispositivos configurados/vistos, mensajes de la última hora, conectados, alarmas de la última hora.</li>
          <li>Sección <strong>Dispositivos</strong>: lista con estado (conectado/desconectado), client id, IP y hora de conexión. Cada fila tiene iconos de acción.</li>
          <li><strong>Suscripciones</strong> (tópicos MQTT activos) y <strong>Automatizaciones</strong> (reglas).</li>
        </ul>

        <h3>6.2. Dispositivos: iconos de acción por fila</h3>
        <table>
          <thead><tr><th>Icono</th><th>Acción</th><th>Resultado</th></tr></thead>
          <tbody>
            <tr><td>📍</td><td>Mapa</td><td>Abre el mapa mostrando <strong>solo ese dispositivo</strong>.</td></tr>
            <tr><td>⌨️</td><td>Comando</td><td>Ventana para enviar un comando (relé / mensaje).</td></tr>
            <tr><td>💬</td><td>Mensajes</td><td>Envía un mensaje al conductor de ese dispositivo.</td></tr>
            <tr><td>📈</td><td>Telemetría</td><td>Ventana de telemetría en vivo filtrada a ese dispositivo.</td></tr>
            <tr><td>📊</td><td>Reportes</td><td>Abre reportes con ese dispositivo preseleccionado.</td></tr>
            <tr><td>🔔</td><td>Alarmas</td><td>Ventana de alarmas filtrada a ese dispositivo.</td></tr>
            <tr><td>🔧</td><td>Mantenimiento</td><td>Mantenimiento solo de ese dispositivo.</td></tr>
            <tr><td>⛽</td><td>Combustible</td><td>Gráfica de combustible de ese dispositivo.</td></tr>
            <tr><td>⏻</td><td>Relevadores</td><td>Control de relés (ON/OFF) de ese dispositivo.</td></tr>
            <tr><td>⚙️</td><td>Config</td><td>Renombrar el dispositivo (admin).</td></tr>
          </tbody>
        </table>

        <h3>6.3. Alta de dispositivo (ejemplo)</h3>
        <ol>
          <li>En la cabecera de <strong>Dispositivos</strong> pulsa el botón <strong>+</strong>.</li>
          <li>Indica <code className="inline">Device ID</code> (ej. <code className="inline">camion-07</code>), nombre opcional y contraseña (o autogenerar).</li>
          <li>La plataforma crea el usuario MQTT, el dispositivo en Traccar y lo asocia a tu empresa.</li>
          <li>Configura el ESP32 con ese mismo <code className="inline">Device ID</code> y las credenciales MQTT.</li>
        </ol>

        <h3>6.4. Mapa</h3>
        <p>Capas (OSM, satélite Esri, topográfico), lista de dispositivos con estado MQTT/localización, historial de rutas con <strong>reproducción</strong>, pantalla completa (Esc), y editor de geocercas (círculo/polígono) con clic derecho.</p>

        <h3>6.5. Flota</h3>
        <p>Panorama de todas las unidades: en línea (MQTT), reportando (localización), velocidad, odómetro, alarmas del día y mantenimiento pendiente.</p>

        <h3>6.6. Viajes (cadena de frío)</h3>
        <p>Se crea un viaje (tractor + caja + cliente + rangos de temperatura). Genera un <strong>enlace público</strong> <code className="inline">/track/&#123;token&#125;</code> para que el cliente vea el seguimiento sin iniciar sesión.</p>

        <h3>6.7. Ejemplo operativo completo</h3>
        <ol>
          <li>Superadmin crea la empresa <em>“Reasapack”</em> con el correo del admin.</li>
          <li>El admin entra y da de alta el dispositivo <code className="inline">camion-01</code>.</li>
          <li>El ESP32 del camión se conecta por MQTT y empieza a reportar <code className="inline">lat/lon/velocidad/combustible/ignición</code>.</li>
          <li>En Dispositivos, el admin pulsa 📍 para ver solo ese camión en el mapa, o 🔔 para sus alarmas.</li>
          <li>Configura una geocerca y una automatización “si sale de la geocerca → activar relé”.</li>
          <li>El despachador crea un viaje y comparte el enlace público con el cliente.</li>
        </ol>
      </section>

      <section className="card" id="topicos">
        <h2>7. Tópicos MQTT y telemetría</h2>
        <p>Convención <code className="inline">devices/&#123;id&#125;/…</code>:</p>
        <table>
          <thead><tr><th>Tópico</th><th>Dirección</th><th>Uso</th></tr></thead>
          <tbody>
            <tr><td className="mono">devices/&#123;id&#125;/data</td><td>dispositivo → servidor</td><td>Telemetría (GPS, sensores)</td></tr>
            <tr><td className="mono">devices/&#123;id&#125;/status</td><td>dispositivo → servidor</td><td>Heartbeat / estado (LWT)</td></tr>
            <tr><td className="mono">devices/&#123;id&#125;/cmd</td><td>servidor → dispositivo</td><td>Comandos</td></tr>
            <tr><td className="mono">devices/&#123;id&#125;/ack</td><td>dispositivo → servidor</td><td>Confirmación de comandos</td></tr>
          </tbody>
        </table>
        <p>Ejemplo de payload (<code className="inline">/data</code>):</p>
        <pre className="code">{PAYLOAD_EXAMPLE}</pre>
      </section>

      <section className="card" id="comandos">
        <h2>8. Comandos — Manual operativo</h2>
        <p>
          Los comandos permiten controlar los dispositivos de forma remota. El flujo es <strong>bidireccional</strong>:
          el servidor publica en <code className="inline">devices/&#123;id&#125;/cmd</code> y el dispositivo responde por
          <code className="inline"> devices/&#123;id&#125;/ack</code>. El firmware de ejemplo implementa dos tipos:
          <code className="inline">relay</code> (relés / corta-corriente) y <code className="inline">message</code> (mensajes
          al conductor). Ambos se envían por el mismo endpoint, cambiando solo <code className="inline">type</code> y
          <code className="inline">params</code>.
        </p>

        <h3>8.1. Formato del mensaje (cmd)</h3>
        <p>Lo que el servidor publica en <code className="inline">devices/&#123;id&#125;/cmd</code>:</p>
        <pre className="code">{`{
  "id": "b02b4cf6-8765-4f66-ba63-dbc50c219871",   // UUID del comando
  "type": "relay",                                 // tipo de comando
  "params": { "relay": 1, "on": true },            // parámetros
  "ts": "2026-09-16T02:16:04.611Z"                 // marca de tiempo
}`}</pre>
        <p>Lo que el dispositivo responde en <code className="inline">devices/&#123;id&#125;/ack</code>:</p>
        <pre className="code">{`{
  "id": "b02b4cf6-8765-4f66-ba63-dbc50c219871",   // mismo id del comando
  "status": "ok",                                  // "ok" | "error"
  "result": { "relay": 1, "on": true }
}`}</pre>

        <h3>8.2. Obtener el token de acceso</h3>
        <p>Todos los ejemplos usan un token Bearer. Se obtiene iniciando sesión:</p>
        <pre className="code">{`curl -s -X POST https://iot.buyubampo.com/api/login \\
  -H "Content-Type: application/json" \\
  -d '{"username":"admin","password":"TU_CONTRASENA"}'
# -> {"token":"...","username":"admin","role":"superadmin",...}`}</pre>

        <h3>8.3. Comando <code className="inline">relay</code> (relés / corta-corriente)</h3>
        <p>
          Controla los dos relés del dispositivo. Parámetros: <code className="inline">relay</code> (1 o 2) y
          <code className="inline">on</code> (<code className="inline">true</code> para encender,
          <code className="inline">false</code> para apagar).
        </p>
        <pre className="code">{`# 1) Encender el relé 1 (corta-corriente)
curl -X POST https://iot.buyubampo.com/api/devices/camion-01/commands \\
  -H "Authorization: Bearer <TOKEN>" -H "Content-Type: application/json" \\
  -d '{"type":"relay","params":{"relay":1,"on":true}}'

# 2) Apagar el relé 1
curl -X POST https://iot.buyubampo.com/api/devices/camion-01/commands \\
  -H "Authorization: Bearer <TOKEN>" -H "Content-Type: application/json" \\
  -d '{"type":"relay","params":{"relay":1,"on":false}}'

# 3) Encender el relé 2
curl -X POST https://iot.buyubampo.com/api/devices/camion-01/commands \\
  -H "Authorization: Bearer <TOKEN>" -H "Content-Type: application/json" \\
  -d '{"type":"relay","params":{"relay":2,"on":true}}'

# 4) Apagar el relé 2
curl -X POST https://iot.buyubampo.com/api/devices/camion-01/commands \\
  -H "Authorization: Bearer <TOKEN>" -H "Content-Type: application/json" \\
  -d '{"type":"relay","params":{"relay":2,"on":false}}'`}</pre>

        <h3>8.4. Comando <code className="inline">message</code> (mensaje al conductor)</h3>
        <p>
          Muestra un texto en la pantalla OLED del vehículo y emite un beep. Parámetro:
          <code className="inline">text</code>.
        </p>
        <pre className="code">{`# 1) Mensaje simple
curl -X POST https://iot.buyubampo.com/api/devices/camion-01/commands \\
  -H "Authorization: Bearer <TOKEN>" -H "Content-Type: application/json" \\
  -d '{"type":"message","params":{"text":"Reportarse a la base"}}'

# 2) Mensaje con acentos y caracteres especiales
curl -X POST https://iot.buyubampo.com/api/devices/camion-01/commands \\
  -H "Authorization: Bearer <TOKEN>" -H "Content-Type: application/json" \\
  -d '{"type":"message","params":{"text":"Cliente espera en Av. Niños Héroes"}}'

# 3) Instrucción de seguridad
curl -X POST https://iot.buyubampo.com/api/devices/camion-01/commands \\
  -H "Authorization: Bearer <TOKEN>" -H "Content-Type: application/json" \\
  -d '{"type":"message","params":{"text":"Detenerse: zona de riesgo"}}'`}</pre>

        <h3>8.5. Consultar el estado de los comandos</h3>
        <p>
          Cada comando queda en <code className="inline">pending</code> y pasa a <code className="inline">ok</code> o
          <code className="inline">error</code> al llegar el ACK del dispositivo.
        </p>
        <pre className="code">{`# Detalle de un comando (el id lo devuelve el POST anterior)
curl -s https://iot.buyubampo.com/api/commands/<ID_DEL_COMANDO> \\
  -H "Authorization: Bearer <TOKEN>"

# Listar comandos de un dispositivo
curl -s "https://iot.buyubampo.com/api/commands?deviceId=camion-01&limit=20" \\
  -H "Authorization: Bearer <TOKEN>"`}</pre>
        <p>Respuesta típica del detalle:</p>
        <pre className="code">{`{
  "id": "b02b4cf6-8765-4f66-ba63-dbc50c219871",
  "device_id": "camion-01",
  "type": "relay",
  "params": "{\\"relay\\":1,\\"on\\":true}",
  "status": "ok",               // pending -> ok | error
  "result": "{\\"relay\\":1,\\"on\\":true}",
  "error": null,
  "created_at": "2026-09-16T02:16:04.611Z",
  "updated_at": "2026-09-16T02:16:05.001Z"
}`}</pre>

        <h3>8.6. Envío directo por MQTT (pruebas / integraciones)</h3>
        <p>
          Si prefieres publicar directo al broker (por ejemplo con <code className="inline">mosquitto_pub</code>),
          usa las credenciales del usuario <code className="inline">backend</code>:
        </p>
        <pre className="code">{`# Encender relé 1 de camion-01
mosquitto_pub -h mqtt.buyubampo.com -p 1883 -u backend -P '<PASS>' \\
  -t 'devices/camion-01/cmd' -q 1 \\
  -m '{"id":"manual-test-001","type":"relay","params":{"relay":1,"on":true},"ts":"2026-09-16T02:16:04.611Z"}'

# Mensaje al conductor
mosquitto_pub -h mqtt.buyubampo.com -p 1883 -u backend -P '<PASS>' \\
  -t 'devices/camion-01/cmd' -q 1 \\
  -m '{"id":"manual-test-002","type":"message","params":{"text":"Prueba de despacho"},"ts":"2026-09-16T02:16:04.611Z"}'`}</pre>
        <p>
          Nota: por la ACL del broker, solo el usuario <code className="inline">backend</code> puede publicar en
          <code className="inline"> devices/#</code>; los dispositivos solo publican en sus propios topics
          (<code className="inline">data</code>, <code className="inline">status</code>, <code className="inline">ack</code>,
          <code className="inline">tts</code>).
        </p>
      </section>

      <section className="card" id="firmware">
        <h2>9. Firmware (código completo)</h2>
        <h3>9.1. Tracker principal (ESP32)</h3>
        <p>Publica telemetría, escucha comandos, controla relés, buzzer y pantalla vía serial.</p>
        <pre className="code">{TRACKER_CODE}</pre>
        <h3>9.2. Unidad de pantalla (ESP32 secundario vía serial)</h3>
        <p>Recibe por UART la línea <code className="inline">MSG:texto</code> y la dibuja en un OLED SSD1306.</p>
        <pre className="code">{DISPLAY_CODE}</pre>
        <h3>9.3. Demo Tracker (ESP32, simplificado)</h3>
        <p>
          Versión mínima del tracker para ESP32: publica telemetría simulada y responde el comando
          <code className="inline">message</code> (no controla relés). Útil para probar el dashboard y la telemetría
          sin cablear nada. Descarga: <code className="inline">https://iot.buyubampo.com/firmware/demo_tracker/demo_tracker.ino</code>
        </p>
        <pre className="code">{DEMO_TRACKER_CODE}</pre>

        <h3>9.4. Tracker NodeMCU v3 (ESP8266)</h3>
        <p>
          Adaptación del tracker para <strong>Lolin NodeMCU v3 (ESP8266/ESP-12E)</strong>. Mismo protocolo
          (topics <code className="inline">devices/&#123;id&#125;/data|status|cmd|ack</code>, comandos
          <code className="inline">relay</code> y <code className="inline">message</code>, LWT). Diferencias vs ESP32:
          usa <code className="inline">ESP8266WiFi.h</code> y <code className="inline">EEPROM.h</code> (en vez de
          <code className="inline">Preferences</code>) y no tiene <code className="inline">Serial1</code>.
          Descarga: <code className="inline">https://iot.buyubampo.com/firmware/tracker_nodemcu/tracker_nodemcu.ino</code>
        </p>
        <table>
          <thead><tr><th>Función</th><th>Pin</th><th>GPIO</th></tr></thead>
          <tbody>
            <tr><td>Relé 1</td><td>D1</td><td>GPIO5</td></tr>
            <tr><td>Relé 2</td><td>D2</td><td>GPIO4</td></tr>
            <tr><td>Ignición (entrada)</td><td>D5</td><td>GPIO14</td></tr>
            <tr><td>Buzzer</td><td>D6</td><td>GPIO12</td></tr>
            <tr><td>Botón config (FLASH)</td><td>D3</td><td>GPIO0</td></tr>
            <tr><td>LED estado</td><td>LED_BUILTIN</td><td>GPIO2</td></tr>
          </tbody>
        </table>
        <p>
          Primer arranque (o manteniendo <code className="inline">GPIO0</code>): portal WiFi
          <code className="inline">Tracker-&lt;MAC&gt;</code> / contraseña derivada del MAC (ver Serial) para
          capturar Device ID, broker y credenciales MQTT.
        </p>
        <pre className="code">{NODEMCU_TRACKER_CODE}</pre>

      </section>

      <section className="card" id="api">
        <h2>10. API (endpoints completos)</h2>
        <table>
          <thead><tr><th>Método</th><th>Ruta</th><th>Descripción / permisos</th></tr></thead>
          <tbody>
            <tr><td>GET</td><td className="mono">/api/health</td><td>Estado del servicio.</td></tr>
            <tr><td>POST</td><td className="mono">/api/login</td><td>Inicio de sesión (devuelve token).</td></tr>
            <tr><td>POST</td><td className="mono">/api/logout</td><td>Cerrar sesión.</td></tr>
            <tr><td>GET</td><td className="mono">/api/me</td><td>Usuario autenticado.</td></tr>
            <tr><td>GET</td><td className="mono">/api/confirm/:token</td><td>Confirmar cuenta por correo.</td></tr>
            <tr><td>POST</td><td className="mono">/api/forgot</td><td>Solicitar recuperación de contraseña.</td></tr>
            <tr><td>POST</td><td className="mono">/api/reset</td><td>Restablecer contraseña con token.</td></tr>
            <tr><td>POST</td><td className="mono">/api/register</td><td>Registro público de empresa + admin.</td></tr>
            <tr><td>POST</td><td className="mono">/api/session/tenant</td><td>Seleccionar empresa (superadmin).</td></tr>
            <tr><td>GET/POST</td><td className="mono">/api/tenants</td><td>Empresas (superadmin).</td></tr>
            <tr><td>PUT/DELETE</td><td className="mono">/api/tenants/:id</td><td>Editar/borrar empresa (superadmin).</td></tr>
            <tr><td>GET/POST</td><td className="mono">/api/users</td><td>Usuarios (según rol).</td></tr>
            <tr><td>POST</td><td className="mono">/api/devices</td><td>Alta de dispositivo (admin/superadmin).</td></tr>
            <tr><td>PUT</td><td className="mono">/api/devices/:id</td><td>Renombrar dispositivo (admin/superadmin).</td></tr>
            <tr><td>POST</td><td className="mono">/api/devices/:id/commands</td><td>Enviar comando (admin/despachador).</td></tr>
            <tr><td>GET</td><td className="mono">/api/commands</td><td>Listar comandos.</td></tr>
            <tr><td>GET</td><td className="mono">/api/commands/:id</td><td>Detalle de un comando.</td></tr>
            <tr><td>GET</td><td className="mono">/api/clients</td><td>Clientes MQTT conectados.</td></tr>
            <tr><td>GET</td><td className="mono">/api/subscriptions</td><td>Suscripciones MQTT.</td></tr>
            <tr><td>GET</td><td className="mono">/api/telemetry</td><td>Telemetría reciente.</td></tr>
            <tr><td>GET</td><td className="mono">/api/stats</td><td>Estadísticas del dashboard.</td></tr>
            <tr><td>GET</td><td className="mono">/api/map</td><td>Dispositivos con última posición.</td></tr>
            <tr><td>GET</td><td className="mono">/api/tracks</td><td>Historial de posiciones.</td></tr>
            <tr><td>GET</td><td className="mono">/api/fleet</td><td>Panorama de flota.</td></tr>
            <tr><td>GET</td><td className="mono">/api/reports</td><td>Reporte (agrega <code>format=csv</code>).</td></tr>
            <tr><td>GET</td><td className="mono">/api/reports/overspeed</td><td>Excesos de velocidad.</td></tr>
            <tr><td>GET</td><td className="mono">/api/reports/stops</td><td>Paradas.</td></tr>
            <tr><td>GET</td><td className="mono">/api/reports/mileage</td><td>Kilometraje.</td></tr>
            <tr><td>GET</td><td className="mono">/api/fuel</td><td>Serie de combustible.</td></tr>
            <tr><td>GET</td><td className="mono">/api/odometer</td><td>Odómetro por dispositivo.</td></tr>
            <tr><td>GET</td><td className="mono">/api/alerts</td><td>Alarmas (agrega <code>format=csv</code>).</td></tr>
            <tr><td>GET/PUT</td><td className="mono">/api/settings</td><td>Umbrales y notificaciones (admin).</td></tr>
            <tr><td>GET/POST/DELETE</td><td className="mono">/api/geofences</td><td>Geocercas (admin).</td></tr>
            <tr><td>GET/POST/DELETE</td><td className="mono">/api/maintenance</td><td>Mantenimiento.</td></tr>
            <tr><td>POST</td><td className="mono">/api/maintenance/:id/done</td><td>Marcar hecho (mecánico).</td></tr>
            <tr><td>GET/POST/DELETE</td><td className="mono">/api/automations</td><td>Automatizaciones (admin).</td></tr>
            <tr><td>POST</td><td className="mono">/api/automations/:id/toggle</td><td>Activar/desactivar.</td></tr>
            <tr><td>GET/POST</td><td className="mono">/api/trips</td><td>Viajes (admin/despachador).</td></tr>
            <tr><td>POST</td><td className="mono">/api/trips/:id/start|complete|cancel</td><td>Cambio de estado de viaje.</td></tr>
            <tr><td>GET</td><td className="mono">/api/track/:token</td><td>Seguimiento público de viaje.</td></tr>
          </tbody>
        </table>
      </section>

      <section className="card" id="usos">
        <h2>11. Usos y alcances</h2>
        <ul>
          <li><strong>Localización satelital:</strong> posición en tiempo real, historial y reproducción de rutas.</li>
          <li><strong>Logística y transporte:</strong> flota, viajes, reparto, cadena de frío (temperatura por viaje) y enlace público para clientes.</li>
          <li><strong>Seguridad vehicular:</strong> corta-corriente por relé, geocercas, alarmas (velocidad, batería, ignición, desconexión).</li>
          <li><strong>Mantenimiento:</strong> programación por kilometraje y control de servicios.</li>
          <li><strong>Combustible:</strong> monitoreo de nivel y detección de llenados/vaciados.</li>
          <li><strong>Automatización:</strong> reglas “si ocurre X, haz Y” (relé, webhook, MQTT).</li>
          <li><strong>Multi-empresa:</strong> un solo despliegue sirve a varias empresas aisladas entre sí.</li>
        </ul>
        <p><strong>Alcance:</strong> el diseño multi-tenant y por tópicos MQTT permite escalar a cientos de dispositivos y varias empresas, y añadir nuevos tipos de sensor sin tocar el núcleo (solo se agregan campos al payload y paneles nuevos).</p>
      </section>

      <section className="card" id="agregados">
        <h2>12. Posibles agregados</h2>
        <h3>En los dispositivos</h3>
        <ul>
          <li>GPS real (TinyGPS++) en lugar del modo demo; módulo LTE/4G (SIM7600/A7670) además de WiFi.</li>
          <li>Lector de bus del vehículo (OBD-II / J1939) para velocidad, RPM, combustible y códigos de falla.</li>
          <li>Cámara, sensor de puertas, acelerómetro/impacto, sonda de temperatura de caja refrigerada.</li>
          <li>Batería de respaldo y almacenamiento local (SD) para no perder datos sin conexión.</li>
          <li>Antena GPS activa y encapsulado resistente (IP67) para uso rudo.</li>
        </ul>
        <h3>En la plataforma</h3>
        <ul>
          <li>Historial con filtros y exportación avanzada (Excel/PDF), dashboards por cliente.</li>
          <li>Roles y permisos más finos, facturación por empresa, auditoría de cambios.</li>
          <li>Notificaciones push (app móvil), SMS, correo; geocercas por cliente.</li>
          <li>Puntos de interés (POI), rutas óptimas, optimización de reparto, cercas por horario.</li>
          <li>Panel de administración de sensores agrícolas (ver siguiente sección).</li>
        </ul>
      </section>

      <section className="card" id="agricola">
        <h2>13. Ecosistema de sensores agrícolas (integración futura)</h2>
        <p>
          Hasta ahora la plataforma partió de la localización satelital, la logística y el transporte. El siguiente
          paso es integrar el <strong>universo de sensores y dispositivos agrícolas</strong> dentro del mismo modelo
          multi-tenant y por tópicos MQTT. La arquitectura ya está lista para recibirlos: cada sensor es un
          <strong> dispositivo</strong> con su <code className="inline">Device ID</code> que publica en
          <code className="inline"> devices/&#123;id&#125;/data</code>.
        </p>
        <h3>Sensores y dispositivos agrícolas a integrar</h3>
        <ul>
          <li><strong>Suelo:</strong> humedad, temperatura, conductividad eléctrica (EC), pH, NPK.</li>
          <li><strong>Clima/meteorología:</strong> estación meteorológica (temperatura, humedad relativa, radiación solar, viento, lluvia, presión).</li>
          <li><strong>Agua/riego:</strong> caudalímetro, nivel de pozo/tanque, válvulas y electroválvulas (comandos de apertura/cierre), presión de riego.</li>
          <li><strong>Ambiente de cultivo:</strong> CO₂, temperatura y humedad en invernadero, sensores de luz.</li>
          <li><strong>Maquinaria:</strong> tractores con GPS + telemetría del motor (ya soportado), cosechadoras, bombas.</li>
          <li><strong>Actuadores:</strong> motores de riego, fertirriego, ventiladores, cortinas de invernadero (vía relés/comandos).</li>
        </ul>
        <h3>Cómo se integran en la plataforma</h3>
        <ol>
          <li>Cada sensor/actuador es un <strong>dispositivo</strong> (su <code className="inline">Device ID</code> es único).</li>
          <li>Publica telemetría en <code className="inline">devices/&#123;id&#125;/data</code> con campos específicos (ej. <code className="inline">humedad_suelo</code>, <code className="inline">temp_aire</code>, <code className="inline">caudal</code>).</li>
          <li>Recibe <strong>comandos</strong> en <code className="inline">devices/&#123;id&#125;/cmd</code> (ej. abrir válvula, encender bomba).</li>
          <li>Las <strong>automatizaciones</strong> cierran el ciclo: “si la humedad del suelo &lt; umbral → abrir válvula de riego”.</li>
        </ol>
        <h3>Ejemplo de payload agrícola</h3>
        <pre className="code">{`// devices/sensor-suelo-01/data
{
  "lat": 24.8091, "lon": -107.3940,
  "humedad_suelo": 28,      // %
  "temp_suelo": 22.4,       // °C
  "ec": 1.8,                // dS/m
  "ph": 6.5,
  "caudal": 12.5,           // L/min
  "nivel_tanque": 62,       // %
  "batt": 3.7
}`}</pre>
        <p>
          Con esto se puede ofrecer, por ejemplo, <strong>riego inteligente</strong>, alertas de helada, monitoreo de
          invernadero y fertirriego, todo dentro del mismo dashboard multi-empresa. La recomendación es añadir
          paneles específicos (Suelo, Clima, Riego, Invernadero) reutilizando el patrón de “ventanas flotantes” ya
          implementado.
        </p>
      </section>

      <section className="card" id="tts">
        <h2>14. Text-to-Speech (TTS) — Unidades de voz</h2>
        <p className="lead">
          El servicio convierte texto en audio con voces naturales de Microsoft Edge. Está expuesto en
          <code className="inline"> https://iot.buyubampo.com/api/tts</code> y devuelve MP3 (para web) o
          <strong>WAV PCM 16-bit / 16 kHz / mono</strong> (para ESP32/I2S).
        </p>
        <p>API Key: <code className="inline">&lt;TU_API_KEY&gt;</code> (configúrala en el portal del dispositivo)</p>
        <p>Endpoints:</p>
        <pre className="code">{`GET /api/tts?key=CLAVE&text=Hola&format=wav   # sintetizar (mp3 | wav)
GET /api/tts/voices                              # listar voces (sin clave)`}</pre>
        <p>Ejemplo:</p>
        <pre className="code">{`curl "https://iot.buyubampo.com/api/tts?key=TU_API_KEY&text=Hola&voice=es-MX-JorgeNeural&format=wav" -o hola.wav`}</pre>

        <p>
          Hay <strong>tres variantes de firmware ESP32</strong>, todas descargables en
          <code className="inline"> https://iot.buyubampo.com/firmware/…</code>:
        </p>
        <ul>
          <li><strong>HTTP directo</strong> (<code className="inline">tts_speaker_http.ino</code>): recomendada, sin MQTT.</li>
          <li><strong>MQTT</strong> (<code className="inline">tts_speaker.ino</code>): publica en <code className="inline">devices/&#123;id&#125;/tts</code> y recibe la URL en <code className="inline">devices/&#123;id&#125;/tts/audio</code>.</li>
          <li><strong>DAC interno</strong> (<code className="inline">tts_speaker_dac.ino</code>): solo ESP32 clásico, sin MAX98357A.</li>
        </ul>
        <p>Disparadores comunes: <code className="inline">SAY:texto</code> por Serial (115200) o botón en <code className="inline">GPIO0</code>.</p>

        <h3>14.1. Cableado I2S (amplificador MAX98357A)</h3>
        <table>
          <thead><tr><th>MAX98357A</th><th>ESP32</th><th>ESP32-S3</th></tr></thead>
          <tbody>
            <tr><td>VIN</td><td>5V</td><td>5V</td></tr>
            <tr><td>GND</td><td>GND</td><td>GND</td></tr>
            <tr><td>BCLK</td><td>26</td><td>15</td></tr>
            <tr><td>LRC</td><td>25</td><td>16</td></tr>
            <tr><td>DIN</td><td>22</td><td>7</td></tr>
          </tbody>
        </table>

        <h3>14.2. Opción A — HTTP directo (recomendado)</h3>
        <p><strong>Descarga:</strong> <code className="inline">https://iot.buyubampo.com/firmware/tts_speaker_http/tts_speaker_http.ino</code></p>
        <pre className="code">{TTS_HTTP_CODE}</pre>

        <h3>14.3. Opción B — MQTT</h3>
        <p><strong>Descarga:</strong> <code className="inline">https://iot.buyubampo.com/firmware/tts_speaker/tts_speaker.ino</code></p>
        <pre className="code">{TTS_MQTT_CODE}</pre>

        <h3>14.4. Opción C — DAC interno (ESP32 clásico, sin MAX98357A)</h3>
        <p>
          <strong>Descarga:</strong> <code className="inline">https://iot.buyubampo.com/firmware/tts_speaker_dac/tts_speaker_dac.ino</code><br />
          Cableado: <code className="inline">GPIO25 ──[+ capacitor 100-470µF -]── entrada amplificador</code> (PAM8403, LM386 o parlantes de PC activos).
          No funciona en ESP32-S2/S3/C3 (no tienen DAC).
        </p>
        <pre className="code">{TTS_DAC_CODE}</pre>
      </section>
    </div>
  );
}
